window.slate = window.slate || {};
window.theme = window.theme || {};


/*================ Slate ================*/
/**
 * A11y Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help make your theme more accessible
 * to users with visual impairments.
 *
 *
 * @namespace a11y
 */

slate.a11y = {

  /**
   * For use when focus shifts to a container rather than a link
   * eg for In-page links, after scroll, focus shifts to content area so that
   * next `tab` is where user expects if focusing a link, just $link.focus();
   *
   * @param {JQuery} $element - The element to be acted upon
   */
  pageLinkFocus: function($element) {
    var focusClass = 'js-focus-hidden';

    $element.first()
    .attr('tabIndex', '-1')
    .focus()
    .addClass(focusClass)
    .one('blur', callback);

    function callback() {
      $element.first()
      .removeClass(focusClass)
      .removeAttr('tabindex');
    }
  },

  /**
   * If there's a hash in the url, focus the appropriate element
   */
  focusHash: function() {
    var hash = window.location.hash;

    // is there a hash in the url? is it an element on the page?
    if (hash && document.getElementById(hash.slice(1))) {
      this.pageLinkFocus($(hash));
    }
  },

  /**
   * When an in-page (url w/hash) link is clicked, focus the appropriate element
   */
  bindInPageLinks: function() {
    $('a[href*=#]').on('click', function(evt) {
      this.pageLinkFocus($(evt.currentTarget.hash));
    }.bind(this));
  },

  /**
   * Traps the focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {jQuery} options.$elementToFocus - Element to be focused when focus leaves container
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  trapFocus: function(options) {
    var eventName = options.namespace
    ? 'focusin.' + options.namespace
    : 'focusin';

    if (!options.$elementToFocus) {
      options.$elementToFocus = options.$container;
    }

    options.$container.attr('tabindex', '-1');
    options.$elementToFocus.focus();

    $(document).on(eventName, function(evt) {
      if (options.$container[0] !== evt.target && !options.$container.has(evt.target).length) {
        options.$container.focus();
      }
    });
  },

  /**
   * Removes the trap of focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  removeTrapFocus: function(options) {
    var eventName = options.namespace
    ? 'focusin.' + options.namespace
    : 'focusin';

    if (options.$container && options.$container.length) {
      options.$container.removeAttr('tabindex');
    }

    $(document).off(eventName);
  }
};

/**
 * Cart Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Cart template.
 *
 * @namespace cart
 */

slate.cart = {

  /**
   * Browser cookies are required to use the cart. This function checks if
   * cookies are enabled in the browser.
   */
  cookiesEnabled: function() {
    var cookieEnabled = navigator.cookieEnabled;

    if (!cookieEnabled){
      document.cookie = 'testcookie';
      cookieEnabled = (document.cookie.indexOf('testcookie') !== -1);
    }
    return cookieEnabled;
  }
};

/**
 * Utility helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions for dealing with arrays and objects
 *
 * @namespace utils
 */

slate.utils = {

  /**
   * Return an object from an array of objects that matches the provided key and value
   *
   * @param {array} array - Array of objects
   * @param {string} key - Key to match the value against
   * @param {string} value - Value to get match of
   */
  findInstance: function(array, key, value) {
    for (var i = 0; i < array.length; i++) {
      if (array[i][key] === value) {
        return array[i];
      }
    }
  },

  /**
   * Remove an object from an array of objects by matching the provided key and value
   *
   * @param {array} array - Array of objects
   * @param {string} key - Key to match the value against
   * @param {string} value - Value to get match of
   */
  removeInstance: function(array, key, value) {
    var i = array.length;
    while(i--) {
      if (array[i][key] === value) {
        array.splice(i, 1);
        break;
      }
    }

    return array;
  },

  /**
   * _.compact from lodash
   * Remove empty/false items from array
   * Source: https://github.com/lodash/lodash/blob/master/compact.js
   *
   * @param {array} array
   */
  compact: function(array) {
    var index = -1;
    var length = array == null ? 0 : array.length;
    var resIndex = 0;
    var result = [];

    while (++index < length) {
      var value = array[index];
      if (value) {
        result[resIndex++] = value;
      }
    }
    return result;
  },

  /**
   * _.defaultTo from lodash
   * Checks `value` to determine whether a default value should be returned in
   * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
   * or `undefined`.
   * Source: https://github.com/lodash/lodash/blob/master/defaultTo.js
   *
   * @param {*} value - Value to check
   * @param {*} defaultValue - Default value
   * @returns {*} - Returns the resolved value
   */
  defaultTo: function(value, defaultValue) {
    return (value == null || value !== value) ? defaultValue : value
  }
};

/**
 * Rich Text Editor
 * -----------------------------------------------------------------------------
 * Wrap iframes and tables in div tags to force responsive/scrollable layout.
 *
 * @namespace rte
 */

slate.rte = {
  /**
   * Wrap tables in a container div to make them scrollable when needed
   *
   * @param {object} options - Options to be used
   * @param {jquery} options.$tables - jquery object(s) of the table(s) to wrap
   * @param {string} options.tableWrapperClass - table wrapper class name
   */
  wrapTable: function(options) {
    var tableWrapperClass = typeof options.tableWrapperClass === "undefined" ? '' : options.tableWrapperClass;

    options.$tables.wrap('<div class="' + tableWrapperClass + '"></div>');
  },

  /**
   * Wrap iframes in a container div to make them responsive
   *
   * @param {object} options - Options to be used
   * @param {jquery} options.$iframes - jquery object(s) of the iframe(s) to wrap
   * @param {string} options.iframeWrapperClass - class name used on the wrapping div
   */
  wrapIframe: function(options) {
    var iframeWrapperClass = typeof options.iframeWrapperClass === "undefined" ? '' : options.iframeWrapperClass;

    options.$iframes.each(function() {
      // Add wrapper to make video responsive
      $(this).wrap('<div class="' + iframeWrapperClass + '"></div>');

      // Re-set the src attribute on each iframe after page load
      // for Chrome's "incorrect iFrame content on 'back'" bug.
      // https://code.google.com/p/chromium/issues/detail?id=395791
      // Need to specifically target video and admin bar
      this.src = this.src;
    });
  }
};

slate.Sections = function Sections() {
  this.constructors = {};
  this.instances = [];

  $(document)
  .on('shopify:section:load', this._onSectionLoad.bind(this))
  .on('shopify:section:unload', this._onSectionUnload.bind(this))
  .on('shopify:section:select', this._onSelect.bind(this))
  .on('shopify:section:deselect', this._onDeselect.bind(this))
  .on('shopify:section:reorder', this._onReorder.bind(this))
  .on('shopify:block:select', this._onBlockSelect.bind(this))
  .on('shopify:block:deselect', this._onBlockDeselect.bind(this));
};

slate.Sections.prototype = $.extend({}, slate.Sections.prototype, {
  _createInstance: function(container, constructor) {
    var $container = $(container);
    var id = $container.attr('data-section-id');
    var type = $container.attr('data-section-type');

    constructor = constructor || this.constructors[type];

    if (typeof constructor === 'undefined') {
      return;
    }

    var instance = $.extend(new constructor(container), {
      id: id,
      type: type,
      container: container
    });

    this.instances.push(instance);
  },

  _onSectionLoad: function(evt) {
    var container = $('[data-section-id]', evt.target)[0];
    if (container) {
      this._createInstance(container);
    }
  },

  _onSectionUnload: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (!instance) {
      return;
    }

    if (typeof instance.onUnload === 'function') {
      instance.onUnload(evt);
    }

    this.instances = slate.utils.removeInstance(this.instances, 'id', evt.detail.sectionId);
  },

  _onSelect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onSelect === 'function') {
      instance.onSelect(evt);
    }
  },

  _onDeselect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onDeselect === 'function') {
      instance.onDeselect(evt);
    }
  },

  _onReorder: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onReorder === 'function') {
      instance.onReorder(evt);
    }
  },

  _onBlockSelect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onBlockSelect === 'function') {
      instance.onBlockSelect(evt);
    }
  },

  _onBlockDeselect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onBlockDeselect === 'function') {
      instance.onBlockDeselect(evt);
    }
  },

  register: function(type, constructor) {
    this.constructors[type] = constructor;

    $('[data-section-type=' + type + ']').each(function(index, container) {
      this._createInstance(container, constructor);
    }.bind(this));
  }
});

/**
 * Currency Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help with currency formatting
 *
 * Current contents
 * - formatMoney - Takes an amount in cents and returns it as a formatted dollar value.
 *
 */

theme.Currency = (function () {
  var moneyFormat = '${{amount}}';

  /**
   * Format money values based on your shop currency settings
   * @param  {Number|string} cents - value in cents or dollar amount e.g. 300 cents
   * or 3.00 dollars
   * @param  {String} format - shop money_format setting
   * @return {String} value - formatted value
   */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') {
      cents = cents.replace('.', '');
    }
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = (format || moneyFormat);

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = slate.utils.defaultTo(precision, 2);
      thousands = slate.utils.defaultTo(thousands, ',');
      decimal = slate.utils.defaultTo(decimal, '.');

      if (isNaN(number) || number == null) {
        return 0;
      }

      number = (number / 100.0).toFixed(precision);

      var parts = number.split('.');
      var dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var centsAmount = parts[1] ? (decimal + parts[1]) : '';

      return dollarsAmount + centsAmount;
    }

    switch (formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
    }

    return formatString.replace(placeholderRegex, value);
  }

  return {
    formatMoney: formatMoney
  };
})();

/**
 * Image Helper Functions
 * -----------------------------------------------------------------------------
 * A collection of functions that help with basic image operations.
 *
 */

slate.Image = (function() {

  /**
   * Preloads an image in memory and uses the browsers cache to store it until needed.
   *
   * @param {Array} images - A list of image urls
   * @param {String} size - A shopify image size attribute
   */

  function preload(images, size) {
    if (typeof images === 'string') {
      images = [images];
    }

    for (var i = 0; i < images.length; i++) {
      var image = images[i];
      this.loadImage(this.getSizedImageUrl(image, size));
    }
  }

  /**
   * Loads and caches an image in the browsers cache.
   * @param {string} path - An image url
   */
  function loadImage(path) {
    new Image().src = path;
  }

  /**
   * Find the Shopify image attribute size
   *
   * @param {string} src
   * @returns {null}
   */
  function imageSize(src) {
    var match = src.match(/.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\.@]/);

    if (match) {
      return match[1];
    } else {
      return null;
    }
  }

  /**
   * Adds a Shopify size attribute to a URL
   *
   * @param src
   * @param size
   * @returns {*}
   */
  function getSizedImageUrl(src, size) {
    if (size === null) {
      return src;
    }

    if (size === 'master') {
      return this.removeProtocol(src);
    }

    var match = src.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);

    if (match) {
      var prefix = src.split(match[0]);
      var suffix = match[0];

      return this.removeProtocol(prefix[0] + '_' + size + suffix);
    } else {
      return null;
    }
  }

  function removeProtocol(path) {
    return path.replace(/http(s)?:/, '');
  }

  return {
    preload: preload,
    loadImage: loadImage,
    imageSize: imageSize,
    getSizedImageUrl: getSizedImageUrl,
    removeProtocol: removeProtocol
  };
})();

/**
 * Variant Selection scripts
 * ------------------------------------------------------------------------------
 *
 * Handles change events from the variant inputs in any `cart/add` forms that may
 * exist. Also updates the master select and triggers updates when the variants
 * price or image changes.
 *
 * @namespace variants
 */

slate.Variants = (function() {

  /**
   * Variant constructor
   *
   * @param {object} options - Settings from `product.js`
   */
  function Variants(options) {
    this.$container = options.$container;
    this.product = options.product;
    this.singleOptionSelector = options.singleOptionSelector;
    this.originalSelectorId = options.originalSelectorId;
    this.enableHistoryState = options.enableHistoryState;
    this.currentVariant = this._getVariantFromOptions();

    $(this.singleOptionSelector, this.$container).on('change', this._onSelectChange.bind(this));
  }

  Variants.prototype = $.extend({}, Variants.prototype, {

    /**
     * Get the currently selected options from add-to-cart form. Works with all
     * form input elements.
     *
     * @return {array} options - Values of currently selected variants
     */
    _getCurrentOptions: function() {
      var currentOptions = $.map($(this.singleOptionSelector, this.$container), function(element) {
        var $element = $(element);
        var type = $element.attr('type');
        var currentOption = {};

        if (type === 'radio' || type === 'checkbox') {
          if ($element[0].checked) {
            currentOption.value = $element.val();
            currentOption.index = $element.data('index');

            return currentOption;
          } else {
            return false;
          }
        } else {
          currentOption.value = $element.val();
          currentOption.index = $element.data('index');

          return currentOption;
        }
      });

      // remove any unchecked input values if using radio buttons or checkboxes
      currentOptions = slate.utils.compact(currentOptions);

      return currentOptions;
    },

    /**
     * Find variant based on selected values.
     *
     * @param  {array} selectedValues - Values of variant inputs
     * @return {object || undefined} found - Variant object from product.variants
     */
    _getVariantFromOptions: function() {
      var selectedValues = this._getCurrentOptions();
      var variants = this.product.variants;
      var found = false;

      variants.forEach(function(variant) {
        var satisfied = true;

        selectedValues.forEach(function(option) {
          if (satisfied) {
            satisfied = (option.value === variant[option.index]);
          }
        });

        
        if (satisfied) {
          found = variant;
        }
        
      });

      return found || null;
    },

    /**
     * Event handler for when a variant input changes.
     */
    _onSelectChange: function() {
      var variant = this._getVariantFromOptions();
      this.$container.trigger({
        type: 'variantChange',
        variant: variant
      });

      if (!variant) {
        return;
      }
      

      this._updateMasterSelect(variant);
      this._exclusiveColorMessage(variant);
      // this._updateImages(variant);
      this._updatePrice(variant);
      this.currentVariant = variant;

      if (this.enableHistoryState) {
        this._updateHistoryState(variant);
      }
      
      if(typeof lz2 === 'object') {
        lz2.observe();
      }
    },

    /**
     * Trigger event when variant image changes
     *
     * @param  {object} variant - Currently selected variant
     * @return {event}  variantImageChange
     */
    _updateImages: function(variant) {
      var variantImage = variant.featured_image || {};
      var currentVariantImage = this.currentVariant.featured_image || {};

      if (!variant.featured_image || variantImage.src === currentVariantImage.src) {
        return;
      }

      this.$container.trigger({
        type: 'variantImageChange',
        variant: variant
      });
    },

    /**
     * Trigger event when variant price changes.
     *
     * @param  {object} variant - Currently selected variant
     * @return {event} variantPriceChange
     */
    _updatePrice: function(variant) {
      if (variant.price === this.currentVariant.price && variant.compare_at_price === this.currentVariant.compare_at_price) {
        return;
      }

      this.$container.trigger({
        type: 'variantPriceChange',
        variant: variant
      });
    },

    /**
     * Update history state for product deeplinking
     *
     * @param {object} variant - Currently selected variant
     */
    _updateHistoryState: function(variant) {
      if (!history.replaceState || !variant) {
        return;
      }

      var newurl = window.location.protocol + '//' + window.location.host + window.location.pathname + '?variant=' + variant.id;
      window.history.replaceState({path: newurl}, '', newurl);
    },

    /**
     * Update hidden master select of variant change
     *
     * @param {object} variant - Currently selected variant
     */
    _updateMasterSelect: function(variant) {
      $(this.originalSelectorId, this.$container)[0].value = variant.id;
    },
    
     /**
     * Update exclusive label for colors
     */
    _exclusiveColorMessage: function(variant) {
      if (typeof window.metadata[variant.id] != 'undefined' && window.metadata[variant.id].exclusive_color != '') {
        $('.swatch .meata_exclusive').text(window.metadata[variant.id].exclusive_color).addClass('exclusive-tag');
      }else{
        $('.swatch .meata_exclusive').removeClass('exclusive-tag');
      }
    }
  });

  return Variants;
})();


/*================ Sections ================*/
/**
 * Product Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Product template.
 *
   * @namespace product
 */

theme.Product = (function() {
  function Product(container) {
    var $container = (this.$container = $(container));
    var sectionId = $container.attr('data-section-id');
    this.ajaxEnabled = $container.data('ajax-enabled');

    this.settings = {
      // Breakpoints from src/stylesheets/global/variables.scss.liquid
      mediaQueryMediumUp: 'screen and (min-width: 768px)',
      mediaQuerySmall: 'screen and (max-width: 768px)',
      mediaQueryDesktop: 'screen and (min-width: 1025px)',
      mediaQueryTab: 'screen and (max-width: 1024px)',
      bpSmall: false,
      enableHistoryState: $container.data('enable-history-state') || false,
      namespace: '.slideshow-' + sectionId,
      sectionId: sectionId,
      sliderActive: false,
      zoomEnabled: false
    };

    this.selectors = {
      addToCart: '[data-add-to-cart]',
      addToCartText: '[data-add-to-cart-text]',
      cartCount: '[data-cart-count]',
      cartCountBubble: '[data-cart-count-bubble]',
      cartPopup: '[data-cart-popup]',
      cartPopupCartQuantity: '[data-cart-popup-cart-quantity]',
      cartPopupClose: '[data-cart-popup-close]',
      cartPopupDismiss: '[data-cart-popup-dismiss]',
      cartPopupImage: '[data-cart-popup-image]',
      cartPopupImageWrapper: '[data-cart-popup-image-wrapper]',
      cartPopupImagePlaceholder: '[data-cart-popup-image-placeholder]',
      cartPopupPlaceholderSize: '[data-placeholder-size]',
      cartPopupProductDetails: '[data-cart-popup-product-details]',
      cartPopupQuantity: '[data-cart-popup-quantity]',
      cartPopupQuantityLabel: '[data-cart-popup-quantity-label]',
      cartPopupTitle: '[data-cart-popup-title]',
      cartPopupWrapper: '[data-cart-popup-wrapper]',
      loader: '[data-loader]',
      loaderStatus: '[data-loader-status]',
      quantity: '[data-quantity-input]',
      SKU: '.variant-sku',
      productStatus: '[data-product-status]',
      originalSelectorId: '#ProductSelect-' + sectionId,
      productForm: '[data-product-form]',
      errorMessage: '[data-error-message]',
      errorMessageWrapper: '[data-error-message-wrapper]',
      imageZoomWrapper: '[data-image-zoom-wrapper]',
      productImageWraps: '.product-single__photo',
      productThumbImages: '.product-single__thumbnail--' + sectionId,
      productThumbs: '.product-single__thumbnails-' + sectionId,
      productThumbListItem: '.product-single__thumbnails-item',
      productFeaturedImage: '.product-featured-img',
      productThumbsWrapper: '.thumbnails-wrapper',
      saleLabel: '.product-price__sale-label-' + sectionId,
      singleOptionSelector: '.single-option-selector-' + sectionId,
      shopifyPaymentButton: '.shopify-payment-button',
      priceContainer: '[data-price]',
      regularPrice: '[data-regular-price]',
      salePrice: '[data-sale-price]',
      unitPrice: '[data-unit-price]',
      unitPriceBaseUnit: '[data-unit-price-base-unit]',
      productPolicies: '[data-product-policies]',
      swatches: '.swatch-element',
      mainWrapper: '.product-single__photos'
    };

    this.classes = {
      cartPopupWrapperHidden: 'cart-popup-wrapper--hidden',
      hidden: 'hide',
      visibilityHidden: 'visibility-hidden',
      inputError: 'input--error',
      jsZoomEnabled: 'js-zoom-enabled',
      productOnSale: 'price--on-sale',
      productUnitAvailable: 'price--unit-available',
      productUnavailable: 'price--unavailable',
      productSoldOut: 'price--sold-out',
      cartImage: 'cart-popup-item__image',
      productFormErrorMessageWrapperHidden: 'product-form__error-message-wrapper--hidden',
      activeClass: 'active-thumb'
    };

    this.$quantityInput = $(this.selectors.quantity, $container);
    this.$errorMessageWrapper = $(
      this.selectors.errorMessageWrapper,
      $container
    );
    this.$addToCart = $(this.selectors.addToCart, $container);
    this.$addToCartText = $(this.selectors.addToCartText, this.$addToCart);
    this.$shopifyPaymentButton = $(
      this.selectors.shopifyPaymentButton,
      $container
    );
    this.$productPolicies = $(this.selectors.productPolicies, $container);

    this.$loader = $(this.selectors.loader, this.$addToCart);
    this.$loaderStatus = $(this.selectors.loaderStatus, $container);

    // Stop parsing if we don't have the product json script tag when loading
    // section in the Theme Editor
    if (!$('#ProductJson-' + sectionId).html()) {
      return;
    }

    this.productSingleObject = JSON.parse(
      document.getElementById('ProductJson-' + sectionId).innerHTML
    );

    this.settings.zoomEnabled = $(this.selectors.imageZoomWrapper).hasClass(
      this.classes.jsZoomEnabled
    );
    this._stringOverrides();
    this._initVariants();
    this._initImageSwitch();
    this._initAddToCart();
    this._setActiveThumbnail();
    this._initBreakpoints();
    this._initSwatches();
  }

  Product.prototype = $.extend({}, Product.prototype, {
    _stringOverrides: function() {
      theme.productStrings = theme.productStrings || {};
      $.extend(theme.strings, theme.productStrings);
    },
    _initBreakpoints: function(){
      var self = this;

      enquire.register(this.settings.mediaQuerySmall, {
        match: function() {
          // initialize thumbnail slider on mobile if more than four thumbnails
          // if ($(self.selectors.productThumbImages).length > 5) {
          //   self._initThumbnailSlider();
          // }

          self._mobileSlick();
          // destroy image zooming if enabled
          if (self.settings.zoomEnabled) {
            $(self.selectors.imageZoomWrapper).each(function() {
              _destroyZoom(this);
            });
          }
          // if (self.settings.zoomEnabled) {
          //     $(self.selectors.imageZoomWrapper).each(function() {
          //       _enableZoom(this);
          //     });
          //   }

          self.settings.bpSmall = true;
        },
        unmatch: function() {
          if (self.settings.sliderActive) {
            self._destroyThumbnailSlider();
          }
          $('.product-single__photos').slick('unslick');
          self.settings.bpSmall = false;
        }
      });
      enquire.register(this.settings.mediaQueryTab, {
        match: function() {

          if (self.settings.zoomEnabled) {
            $(self.selectors.imageZoomWrapper).each(function() {
              _destroyZoom(this);
            });
          }

        },
        unmatch: function() {

        }
      });
      enquire.register(this.settings.mediaQueryDesktop, {
        match: function() {


          if (self.settings.zoomEnabled) {
            $(self.selectors.imageZoomWrapper).each(function() {
              _enableZoom(this);
            });
          }


        },
        unmatch: function() {

        }
      });
      enquire.register(this.settings.mediaQueryMediumUp, {
        match: function() {
          if ($(self.selectors.productThumbImages).length > 5) {
            self._initThumbnailSlider();
          }

        }
      });
    },

    _mobileSlick: function() {
      var video_index = $('.product-single__photos').attr('data-index');
      var mob_video_tag = $('.product-single_video').parents('.product-single__photo-wrapper.video-grid').html();
      $('.product-single__photo-wrapper.video-grid').remove();
      var newDiv_mob = $('<div class="product-single__photo-wrapper product-single_video"></div>').append(mob_video_tag);   
      $('.product-single__photo-wrapper').eq(video_index).after(newDiv_mob);
      $('.product-single__photos').slick({
        dots: false,
        infinite: true,
        arrows: true,
        slidesToShow: 1,
        slidesToScroll: 1,
      });
    },

    _initSwatches: function() {
      var self = this;
      if( $('.swatch-element input[data-aria-selected="true"]').val() != '' &&  $('.swatch-element input[data-aria-selected="true"]').length > 0 ){
        var selectedColor = $('.swatch-element input[data-aria-selected="true"]').val();
        var data_variant_id = $('.swatch-element input[data-aria-selected="true"]').attr('data-variant');
        
        
        selectedColor = selectedColor.toLowerCase().replace(/\b[a-z]/g, function(letter) {
          return letter.toUpperCase();
        });
      }

      if (typeof window.metadata !== 'undefined' && typeof window.metadata[data_variant_id] != 'undefined' && window.metadata[data_variant_id].exclusive_color != '') {
        $('.swatch .meata_exclusive').text(window.metadata[data_variant_id].exclusive_color).addClass('exclusive-tag');
      }else{
        $('.swatch .meata_exclusive').removeClass('exclusive-tag');
      }
      
      $('.product-form .swatch-container').find('.selected_color').html('');
      $('.swatch-element input[data-aria-selected="true"]').parents('.swatch.clearfix').find('.selected_color').html(selectedColor);
      $('body').on('change','.swatch-element input', function() {

        var colorVal = $(this).val();
        colorVal = colorVal.toLowerCase().replace(/\b[a-z]/g, function(letter) {
          return letter.toUpperCase();
        });
        console.log(colorVal);
		$(this).parents('.swatch-container').find('.swatch-element input').attr('data-aria-selected','false');
        $(this).attr('data-aria-selected','true');
        $('.product-form .swatch-container').find('.selected_color').html('');
        $(this).parents('.swatch.clearfix').find('.selected_color').html(colorVal);
        var productTitle = $(this).data('url');
        url = productTitle;    

       const currentPath = window.location.pathname + window.location.search;
       $.get(currentPath, function(response, status){
          if($(window).width()>768) {
            var newsliderHtml = $(response).find('.product-single__thumbnails').html(),
                newMainWrapper = $(response).find('.product-single__photos').html(),
                options = {
                  adaptiveHeight: true,
                  vertical: true,
                  verticalScrolling: true,
                  slidesToShow: 5,
                  slidesToScroll: 1,
                  focusOnSelect: false,
                  infinite: false,
                  draggable:true,
                  prevArrow: '.thumbnails-wrapper .thumbnails-slider__prev',
                  nextArrow: '.thumbnails-wrapper .thumbnails-slider__next',
                  responsive: [
                    {
                      breakpoint: 321,
                      settings: {
                        slidesToShow: 3
                      }
                    }
                  ]
                };

            if ($('.product-single__thumbnails').hasClass('slick-initialized')) {
              $('.product-single__thumbnails').slick('unslick');
            }
            $('.product-single__thumbnails').empty();
            $('.product-single__thumbnails').html(newsliderHtml);
            $('.product-single__thumbnails').slick(options);
            $('.product-single__thumbnails').slick('slickGoTo', 0);
            //   const lazyLoad = new LazyLoad({
            //     elements_selector: '.product-single__thumbnail,.product-single__thumbnail-image'
            // });
            // lazyLoad.update();
            $('.product-single__photos').empty();
            $('.product-single__photos').html(newMainWrapper);
            $('.slick-active').find('.product-single__thumbnail--product').first().addClass('active-thumb');
            if(typeof lz2 === 'object') {
              setTimeout(() => lz2.observe(), 100);
            }

          } else {
            var mob_video_tag = $(response).find('.product-single_video').parents('.product-single__photo-wrapper.video-grid').html();
            var video_index = $('.product-single__photos').attr('data-index'); 
            var newmobilesliderhtml = $(response).find('.product-single__photos').html();
            if ($('.product-single__thumbnails').hasClass('slick-initialized')) {
              $('.product-single__photos').slick('unslick');
            }
            $('.product-single__photos').slick('unslick');
            $('.product-single__photos').empty();
            $('.product-single__photos').html(newmobilesliderhtml);
            $('.product-single__photo-wrapper.video-grid').remove();
            var newDiv_mob = $('<div class="product-single__photo-wrapper product-single_video"></div>').append(mob_video_tag);
            $('.product-single__photo-wrapper').eq(video_index).after(newDiv_mob);
            $('.product-single__photos').not('.slick-initialized').slick({
              dots: false,
              infinite: true,
              arrows: true,
              slidesToShow: 1,
              slidesToScroll: 1,
            });
            // $('.product-single__photos').slick('slickGoTo', 0);


            if(typeof lz2 === 'object') {
              setTimeout(() => lz2.observe(), 100);
            }
          }

          enquire.register('screen and (min-width: 1025px)', {
            match: function() {
              $('[data-image-zoom-wrapper]').each(function() {
                _enableZoom(this);
              });
            },
            unmatch: function() {
            }
          });
          var photo_length = $(response).find('.product-single__photos').find('.product-single__photo-wrapper').length;
          if(photo_length > 6){
            $('.product-gallery__expand').show();
          }else{
            $('.product-gallery__expand').hide();
          }
          var newModelImages = $(response).find('.product-gallery__zoom-container').html();
          $('.product-gallery__zoom-container').html(newModelImages);
          
        });
        // $.get(url, function(response, status){
        //   console.log(response,'response-------------------==============')
        //   if($(window).width()>768) {
        //     var newsliderHtml = $(response).find('.product-single__thumbnails').html(),
        //         newMainWrapper = $(response).find('.product-single__photos').html(),
        //         options = {
        //           adaptiveHeight: true,
        //           vertical: true,
        //           verticalScrolling: true,
        //           slidesToShow: 5,
        //           slidesToScroll: 1,
        //           focusOnSelect: false,
        //           infinite: false,
        //           draggable:true,
        //           prevArrow: '.thumbnails-wrapper .thumbnails-slider__prev',
        //           nextArrow: '.thumbnails-wrapper .thumbnails-slider__next',
        //           responsive: [
        //             {
        //               breakpoint: 321,
        //               settings: {
        //                 slidesToShow: 3
        //               }
        //             }
        //           ]
        //         };

        //     if ($('.product-single__thumbnails').hasClass('slick-initialized')) {
        //       $('.product-single__thumbnails').slick('unslick');
        //     }
        //     $('.product-single__thumbnails').empty();
        //     $('.product-single__thumbnails').html(newsliderHtml);
        //     $('.product-single__thumbnails').slick(options);
        //     $('.product-single__thumbnails').slick('slickGoTo', 0);
        //     //   const lazyLoad = new LazyLoad({
        //     //     elements_selector: '.product-single__thumbnail,.product-single__thumbnail-image'
        //     // });
        //     // lazyLoad.update();
        //     $('.product-single__photos').empty();
        //     $('.product-single__photos').html(newMainWrapper);
        //     $('.slick-active').find('.product-single__thumbnail--product').first().addClass('active-thumb');
        //     if(typeof lz2 === 'object') {
        //       setTimeout(() => lz2.observe(), 100);
        //     }

        //   } else {
        //     var mob_video_tag = $(response).find('.product-single_video').parents('.product-single__photo-wrapper.video-grid').html();
        //     var video_index = $('.product-single__photos').attr('data-index'); 
        //     var newmobilesliderhtml = $(response).find('.product-single__photos').html();
        //     if ($('.product-single__thumbnails').hasClass('slick-initialized')) {
        //       $('.product-single__photos').slick('unslick');
        //     }
        //     $('.product-single__photos').slick('unslick');
        //     $('.product-single__photos').empty();
        //     $('.product-single__photos').html(newmobilesliderhtml);
        //     $('.product-single__photo-wrapper.video-grid').remove();
        //     var newDiv_mob = $('<div class="product-single__photo-wrapper product-single_video"></div>').append(mob_video_tag);
        //     $('.product-single__photo-wrapper').eq(video_index).after(newDiv_mob);
        //     $('.product-single__photos').not('.slick-initialized').slick({
        //       dots: false,
        //       infinite: true,
        //       arrows: true,
        //       slidesToShow: 1,
        //       slidesToScroll: 1,
        //     });
        //     // $('.product-single__photos').slick('slickGoTo', 0);


        //     if(typeof lz2 === 'object') {
        //       setTimeout(() => lz2.observe(), 100);
        //     }
        //   }

        //   enquire.register('screen and (min-width: 1025px)', {
        //     match: function() {
        //       $('[data-image-zoom-wrapper]').each(function() {
        //         _enableZoom(this);
        //       });
        //     },
        //     unmatch: function() {
        //     }
        //   });
        //   var photo_length = $(response).find('.product-single__photos').find('.product-single__photo-wrapper').length;
        //   if(photo_length > 6){
        //     $('.product-gallery__expand').show();
        //   }else{
        //     $('.product-gallery__expand').hide();
        //   }
        //   var newModelImages = $(response).find('.product-gallery__zoom-container').html();
        //   $('.product-gallery__zoom-container').html(newModelImages);
          
        // })
      });
      $('.swatch-element input:checked').change();
      // $.get(url, function(response, status){

      //   console.log(response)
      //   // Create slider
      //   var newsliderHtml = $(response).find('.product__details .product__slideshow').html();
      //   $('.product__slideshow').slick('unslick');
      //   $('.product__slideshow').empty();
      //   $('.product__slideshow').html(newsliderHtml);
      //   $('.product__slideshow').slick('init');
      //   $('.product__slideshow').slick('slickFilter', ':not(.liquidpixel-image)');
      //   $('.product__slideshow').slick('slickGoTo', 0);
      // })
    },

    _initVariants: function() {
      var options = {
        $container: this.$container,
        enableHistoryState:
        this.$container.data('enable-history-state') || false,
        singleOptionSelector: this.selectors.singleOptionSelector,
        originalSelectorId: this.selectors.originalSelectorId,
        product: this.productSingleObject
      };

      this.variants = new slate.Variants(options);

      this.$container.on(
        'variantChange' + this.settings.namespace,
        this._updateAvailability.bind(this)
      );
      this.$container.on(
        'variantImageChange' + this.settings.namespace,
        this._updateImages.bind(this)
      );
      this.$container.on(
        'variantPriceChange' + this.settings.namespace,
        this._updatePrice.bind(this)
      );
      this.$container.on(
        'variantSKUChange' + this.settings.namespace,
        this._updateSKU.bind(this)
      );
    },

    _initImageSwitch: function() {
      if (!$(this.selectors.productThumbImages).length) {
        return;
      }

      var self = this;

      $(document)
      .on('click',this.selectors.productThumbImages, function(evt) {
        evt.preventDefault();
        var $el = $(this);

        var imageId = $el.data('thumbnail-id');

        self._switchImage(imageId);
        self._setActiveThumbnail(imageId);
      })
      .on('keyup', self._handleImageFocus.bind(self));
    },

    _initAddToCart: function() {
      $(this.selectors.productForm, this.$container).on(
        'submit',
        function(evt) {
          if (this.$addToCart.is('[aria-disabled]')) {
            evt.preventDefault();
            return;
          }
          $('.error_color').remove();
          var hasCustomAdd = false;
          $('.errorMsg').remove();
          if($('.product-form__cart-submit').closest('form').find('.upsell-option input[type="checkbox"]').length) {
            if($('.product-form__cart-submit').closest('form').find('.upsell-option input[type="checkbox"]:checked').length) {
              $('.product-form__cart-submit').closest('form').find('.upsell-option input[type="checkbox"]:checked').each(function(){
                var optionBox = $(this).closest('.upsell-option');
                console.log('Idfn');
                if(optionBox.find('input[type="radio"]:checked').length==0) {
                  hasCustomAdd = true;
                  optionBox.find('.inner_swatch').append('<p class="errorMsg">Please select color</p>');
                  // return false;
                }
              });
            }
          }
          if(hasCustomAdd) {
            return false;
          }


          if($('.upsell-option.active_u input:radio[name=mainPdetails]').length){
            var hasCustomAdd_radio = false;
            if($('.product-form__cart-submit').closest('form').find('.upsell-option input[type="radio"]').length) {
              if($('.product-form__cart-submit').closest('form').find('.upsell-option input[type="radio"]:checked').length <= 1) {
                console.log('In');
                if($('.upsell-option.active_u').find('input[type="radio"]:checked').length <= 1 ) {
                  hasCustomAdd_radio = true;
                  $('.upsell-option.active_u').find('.inner_swatch').append('<p class="errorMsg">Please select color</p>');
                  //                   return false;
                }
              }
            }
            if(hasCustomAdd_radio) {
              return false;
            }
          }










          if (!this.ajaxEnabled) return;

          evt.preventDefault();

          this.$previouslyFocusedElement = $(':focus');

          var isInvalidQuantity = this.$quantityInput.val() <= 0;

          if (isInvalidQuantity) {
            this._showErrorMessage(theme.strings.quantityMinimumMessage);
            return;
          }

          if (!isInvalidQuantity && this.ajaxEnabled) {
            // disable the addToCart and dynamic checkout button while
            // request/cart popup is loading and handle loading state
            this._handleButtonLoadingState(true);
            var $data = $(this.selectors.productForm, this.$container);
            this._addItemToCart($data);
            return;
          }
        }.bind(this)
      );
    },

    _addItemToCart: function(data) {
      var params = {
        url: '/cart/add.js',
        data: $(data).serialize(),
        dataType: 'json'
      };

      $.post(params)
      .done(
        function(item) {
          this._hideErrorMessage();
          this._setupCartPopup(item);
        }.bind(this)
      )
      .fail(
        function(response) {
          this.$previouslyFocusedElement.focus();
          var errorMessage = response.responseJSON
          ? response.responseJSON.description
          : theme.strings.cartError;
          this._showErrorMessage(errorMessage);
          this._handleButtonLoadingState(false);
        }.bind(this)
      );
    },

    _handleButtonLoadingState: function(isLoading) {
      if (isLoading) {
        this.$addToCart.attr('aria-disabled', true);
        this.$addToCartText.addClass(this.classes.hidden);
        this.$loader.removeClass(this.classes.hidden);
        this.$shopifyPaymentButton.attr('disabled', true);
        this.$loaderStatus.attr('aria-hidden', false);
      } else {
        this.$addToCart.removeAttr('aria-disabled');
        this.$addToCartText.removeClass(this.classes.hidden);
        this.$loader.addClass(this.classes.hidden);
        this.$shopifyPaymentButton.removeAttr('disabled');
        this.$loaderStatus.attr('aria-hidden', true);
      }
    },

    _showErrorMessage: function(errorMessage) {
      $(this.selectors.errorMessage, this.$container).html(errorMessage);

      if (this.$quantityInput.length !== 0) {
        this.$quantityInput.addClass(this.classes.inputError);
      }

      this.$errorMessageWrapper
      .removeClass(this.classes.productFormErrorMessageWrapperHidden)
      .attr('aria-hidden', true)
      .removeAttr('aria-hidden');
    },

    _hideErrorMessage: function() {
      this.$errorMessageWrapper.addClass(
        this.classes.productFormErrorMessageWrapperHidden
      );

      if (this.$quantityInput.length !== 0) {
        this.$quantityInput.removeClass(this.classes.inputError);
      }
    },

    _setupCartPopup: function(item) {
      this.$cartPopup = this.$cartPopup || $(this.selectors.cartPopup);
      this.$cartPopupWrapper =
        this.$cartPopupWrapper || $(this.selectors.cartPopupWrapper);
      this.$cartPopupTitle =
        this.$cartPopupTitle || $(this.selectors.cartPopupTitle);
      this.$cartPopupQuantity =
        this.$cartPopupQuantity || $(this.selectors.cartPopupQuantity);
      this.$cartPopupQuantityLabel =
        this.$cartPopupQuantityLabel ||
        $(this.selectors.cartPopupQuantityLabel);
      this.$cartPopupClose =
        this.$cartPopupClose || $(this.selectors.cartPopupClose);
      this.$cartPopupDismiss =
        this.$cartPopupDismiss || $(this.selectors.cartPopupDismiss);
      this.$cartPopupImagePlaceholder =
        this.$cartPopupImagePlaceholder ||
        $(this.selectors.cartPopupImagePlaceholder);

      this._setupCartPopupEventListeners();

      this._updateCartPopupContent(item);
    },

    _updateCartPopupContent: function(item) {
      var quantity = this.$quantityInput.length ? this.$quantityInput.val() : 1;

      this.$cartPopupTitle.text(item.product_title);
      this.$cartPopupQuantity.text(quantity);
      this.$cartPopupQuantityLabel.text(
        theme.strings.quantityLabel.replace('[count]', quantity)
      );

      this._setCartPopupPlaceholder(
        item.featured_image.url,
        item.featured_image.aspect_ratio
      );
      this._setCartPopupImage(item.featured_image.url, item.featured_image.alt);
      this._setCartPopupProductDetails(
        item.product_has_only_default_variant,
        item.options_with_values,
        item.properties
      );

      $.getJSON('/cart.js').then(
        function(cart) {
          this._setCartQuantity(cart.item_count);
          this._setCartCountBubble(cart.item_count);
          this._showCartPopup();
        }.bind(this)
      );
    },

    _setupCartPopupEventListeners: function() {
      this.$cartPopupWrapper.on(
        'keyup',
        function(event) {
          if (event.keyCode === slate.utils.keyboardKeys.ESCAPE) {
            this._hideCartPopup(event);
          }
        }.bind(this)
      );

      this.$cartPopupClose.on('click', this._hideCartPopup.bind(this));
      this.$cartPopupDismiss.on('click', this._hideCartPopup.bind(this));
      $('body').on('click', this._onBodyClick.bind(this));
    },

    _setCartPopupPlaceholder: function(imageUrl, imageAspectRatio) {
      this.$cartPopupImageWrapper =
        this.$cartPopupImageWrapper || $(this.selectors.cartPopupImageWrapper);

      if (imageUrl === null) {
        this.$cartPopupImageWrapper.addClass(this.classes.hidden);
        return;
      }

      var $placeholder = $(this.selectors.cartPopupPlaceholderSize);
      var maxWidth = 95 * imageAspectRatio;
      var heightRatio = 100 / imageAspectRatio;

      this.$cartPopupImagePlaceholder.css('max-width', maxWidth);

      $placeholder.css('padding-top', heightRatio + '%');
    },

    _setCartPopupImage: function(imageUrl, imageAlt) {
      if (imageUrl === null) return;

      this.$cartPopupImageWrapper.removeClass(this.classes.hidden);
      var sizedImageUrl = theme.Images.getSizedImageUrl(imageUrl, '200x');
      var image = document.createElement('img');
      image.src = sizedImageUrl;
      image.alt = imageAlt;
      image.classList.add(this.classes.cartImage);
      image.dataset.cartPopupImage = '';

      image.onload = function() {
        this.$cartPopupImagePlaceholder.addClass(this.classes.hidden);
        this.$cartPopupImageWrapper.append(image);
      }.bind(this);
    },

    _setCartPopupProductDetails: function(
    product_has_only_default_variant,
     options,
     properties
    ) {
      this.$cartPopupProductDetails =
        this.$cartPopupProductDetails ||
        $(this.selectors.cartPopupProductDetails);
      var variantPropertiesHTML = '';

      if (!product_has_only_default_variant) {
        variantPropertiesHTML =
          variantPropertiesHTML + this._getVariantOptionList(options);
      }

      if (properties !== null && Object.keys(properties).length !== 0) {
        variantPropertiesHTML =
          variantPropertiesHTML + this._getPropertyList(properties);
      }

      if (variantPropertiesHTML.length === 0) {
        this.$cartPopupProductDetails.html('');
        this.$cartPopupProductDetails.attr('hidden', '');
      } else {
        this.$cartPopupProductDetails.html(variantPropertiesHTML);
        this.$cartPopupProductDetails.removeAttr('hidden');
      }
    },

    _getVariantOptionList: function(variantOptions) {
      var variantOptionListHTML = '';

      variantOptions.forEach(function(variantOption) {
        variantOptionListHTML =
          variantOptionListHTML +
          '<li class="product-details__item product-details__item--variant-option">' +
          variantOption.name +
          ': ' +
          variantOption.value +
          '</li>';
      });

      return variantOptionListHTML;
    },

    _getPropertyList: function(properties) {
      var propertyListHTML = '';
      var propertiesArray = Object.entries(properties);

      propertiesArray.forEach(function(property) {
        // Line item properties prefixed with an underscore are not to be displayed
        if (property[0].charAt(0) === '_') return;

        // if the property value has a length of 0 (empty), don't display it
        if (property[1].length === 0) return;

        propertyListHTML =
          propertyListHTML +
          '<li class="product-details__item product-details__item--property">' +
          '<span class="product-details__property-label">' +
          property[0] +
          ': </span>' +
          property[1];
        ': ' + '</li>';
      });

      return propertyListHTML;
    },

    _setCartQuantity: function(quantity) {
      this.$cartPopupCartQuantity =
        this.$cartPopupCartQuantity || $(this.selectors.cartPopupCartQuantity);
      var ariaLabel;

      if (quantity === 1) {
        ariaLabel = theme.strings.oneCartCount;
      } else if (quantity > 1) {
        ariaLabel = theme.strings.otherCartCount.replace('[count]', quantity);
      }

      this.$cartPopupCartQuantity.text(quantity).attr('aria-label', ariaLabel);
    },

    _setCartCountBubble: function(quantity) {
      this.$cartCountBubble =
        this.$cartCountBubble || $(this.selectors.cartCountBubble);
      this.$cartCount = this.$cartCount || $(this.selectors.cartCount);

      this.$cartCountBubble.removeClass(this.classes.hidden);
      this.$cartCount.text(quantity);
    },

    _showCartPopup: function() {
      this.$cartPopupWrapper
      .prepareTransition()
      .removeClass(this.classes.cartPopupWrapperHidden);
      this._handleButtonLoadingState(false);

      slate.a11y.trapFocus({
        $container: this.$cartPopupWrapper,
        $elementToFocus: this.$cartPopup,
        namespace: 'cartPopupFocus'
      });
    },

    _hideCartPopup: function(event) {
      var setFocus = event.detail === 0 ? true : false;
      this.$cartPopupWrapper
      .prepareTransition()
      .addClass(this.classes.cartPopupWrapperHidden);

      $(this.selectors.cartPopupImage).remove();
      this.$cartPopupImagePlaceholder.removeClass(this.classes.hidden);

      slate.a11y.removeTrapFocus({
        $container: this.$cartPopupWrapper,
        namespace: 'cartPopupFocus'
      });

      if (setFocus) this.$previouslyFocusedElement[0].focus();

      this.$cartPopupWrapper.off('keyup');
      this.$cartPopupClose.off('click');
      this.$cartPopupDismiss.off('click');
      $('body').off('click');
    },

    _onBodyClick: function(event) {
      var $target = $(event.target);

      if (
        $target[0] !== this.$cartPopupWrapper[0] &&
        !$target.parents(this.selectors.cartPopup).length
      ) {
        this._hideCartPopup(event);
      }
    },

    _setActiveThumbnail: function(imageId) {
      // If there is no element passed, find it by the current product image
      if (typeof imageId === 'undefined') {
        imageId = $(
          this.selectors.productImageWraps + ':not(.hide)',
          this.$container
        ).data('image-id');
      }

      var $thumbnailWrappers = $(
        this.selectors.productThumbListItem + ':not(.slick-cloned)',
        this.$container
      );

      var $activeThumbnail = $thumbnailWrappers.find(
        this.selectors.productThumbImages +
        "[data-thumbnail-id='" +
        imageId +
        "']"
      );

      $(this.selectors.productThumbImages)
      .removeClass(this.classes.activeClass)
      .removeAttr('aria-current');

      $activeThumbnail.addClass(this.classes.activeClass);
      $activeThumbnail.attr('aria-current', true);

      if (!$thumbnailWrappers.hasClass('slick-slide')) {
        return;
      }

      var slideIndex = $activeThumbnail.parent().data('slick-index');

      $(this.selectors.productThumbs).slick('slickGoTo', slideIndex, true);
    },

    _switchImage: function(imageId) {
      var $newImage = $(
        this.selectors.productImageWraps + "[data-image-id='" + imageId + "']",
        this.$container
      );
      var $otherImages = $(
        this.selectors.productImageWraps +
        ":not([data-image-id='" +
        imageId +
        "'])",
        this.$container
      );

      $newImage.removeClass(this.classes.hidden);
      $otherImages.addClass(this.classes.hidden);
    },

    _handleImageFocus: function(evt) {
      if (evt.keyCode !== slate.utils.keyboardKeys.ENTER) return;

      $(this.selectors.productFeaturedImage + ':visible').focus();
    },

    _initThumbnailSlider: function() {
      var options = {
        adaptiveHeight: false,
        vertical: true,
        verticalScrolling: true,
        slidesToShow: 5,
        slidesToScroll: 1,
        focusOnSelect: false,
        infinite: false,
        swipe:true,
        prevArrow: '.thumbnails-slider__prev--' + this.settings.sectionId,
        nextArrow: '.thumbnails-slider__next--' + this.settings.sectionId,
        responsive: [
          {
            breakpoint: 321,
            settings: {
              slidesToShow: 3
            }
          }
        ]
      };

      $(this.selectors.productThumbs).slick(options);

      // Accessibility concerns not yet fixed in Slick Slider
      $(this.selectors.productThumbsWrapper, this.$container)
      .find('.slick-list')
      .removeAttr('aria-live');
      $(this.selectors.productThumbsWrapper, this.$container)
      .find('.slick-disabled')
      .removeAttr('aria-disabled');

      this.settings.sliderActive = true;
    },

    _destroyThumbnailSlider: function() {
      $(this.selectors.productThumbs).slick('unslick');
      this.settings.sliderActive = false;

      // Accessibility concerns not yet fixed in Slick Slider
      $(this.selectors.productThumbsWrapper, this.$container)
      .find('[tabindex="-1"]')
      .removeAttr('tabindex');
    },

    _liveRegionText: function(variant) {
      // Dummy content for live region
      var liveRegionText =
          '[Availability] [Regular] [$$] [Sale] [$]. [UnitPrice] [$$$]';

      if (!variant) {
        liveRegionText = theme.strings.unavailable;
        return liveRegionText;
      }

      // Update availability
      var availability = variant.available ? '' : theme.strings.soldOut + ',';
      liveRegionText = liveRegionText.replace('[Availability]', availability);

      // Update pricing information
      var regularLabel = '';
      var regularPrice = theme.Currency.formatMoney(
        variant.price,
        theme.moneyFormat
      );
      var saleLabel = '';
      var salePrice = '';
      var unitLabel = '';
      var unitPrice = '';

      if (variant.compare_at_price > variant.price) {
        regularLabel = theme.strings.regularPrice;
        regularPrice =
          theme.Currency.formatMoney(
          variant.compare_at_price,
          theme.moneyFormat
        ) + ',';
        saleLabel = theme.strings.sale;
        salePrice = theme.Currency.formatMoney(
          variant.price,
          theme.moneyFormat
        );
      }

      if (variant.unit_price) {
        unitLabel = theme.strings.unitPrice;
        unitPrice =
          theme.Currency.formatMoney(variant.unit_price, theme.moneyFormat) +
          ' ' +
          theme.strings.unitPriceSeparator +
          ' ' +
          this._getBaseUnit(variant);
      }

      liveRegionText = liveRegionText
      .replace('[Regular]', regularLabel)
      .replace('[$$]', regularPrice)
      .replace('[Sale]', saleLabel)
      .replace('[$]', salePrice)
      .replace('[UnitPrice]', unitLabel)
      .replace('[$$$]', unitPrice)
      .trim();

      return liveRegionText;
    },

    _updateLiveRegion: function(evt) {
      var variant = evt.variant;
      var liveRegion = document.querySelector(
        this.selectors.productStatus
      );
      liveRegion.innerHTML = this._liveRegionText(variant);
      liveRegion.setAttribute('aria-hidden', false);

      // hide content from accessibility tree after announcement
      setTimeout(function() {
        liveRegion.setAttribute('aria-hidden', true);
      }, 1000);
    },

    _updateAddToCart: function(evt) {
      var variant = evt.variant;

      // BEGIN SWATCHES
      if (variant) {
        var form = jQuery(this.selectors.productForm);
        for (var i=0,length=variant.options.length; i<length; i++) {
          var radioButton = form.find('.swatch[data-option-index="' + i + '"] :radio[value="' + variant.options[i] +'"]');
          if (radioButton.length > 0) {
            radioButton.get(0).checked = true;
          }
        }
      }
      // END SWATCHES
      if (variant) {
        if (variant.available) {
          this.$addToCart
          .removeAttr('aria-disabled')
          .attr('aria-label', theme.strings.addToCart);
          $(this.selectors.addToCartText, this.$container).text(
            theme.strings.addToCart
          );
          this.$shopifyPaymentButton.show();
          this.$addToCart.removeAttr('disabled');
          $('.product-form__controls-group--submit').removeClass('disabled');
          $('.product-form__controls-group-qty').show();
          $('.product-form__controls-group-qtylbl').show();
        } else {
          // The variant doesn't exist, disable submit button and change the text.
          // This may be an error or notice that a specific variant is not available.
          this.$addToCart
          .attr('aria-disabled', true)
          .attr('aria-label', theme.strings.soldOut);
          $(this.selectors.addToCartText, this.$container).text(
            theme.strings.soldOut
          );
          this.$shopifyPaymentButton.hide();
          this.$addToCart.removeAttr('disabled',true);
          $('.product-form__controls-group--submit').addClass('disabled');
          $('.product-form__controls-group-qty').hide();
          $('.product-form__controls-group-qtylbl').hide();
        }
      } else {
        this.$addToCart
        .attr('aria-disabled', true)
        .attr('aria-label', theme.strings.unavailable);
        $(this.selectors.addToCartText, this.$container).text(
          theme.strings.unavailable
        );
        this.$shopifyPaymentButton.hide();
        this.$addToCart.removeAttr('disabled',true);
      }
    },

    _updateAvailability: function(evt) {
      // remove error message if one is showing
      this._hideErrorMessage();

      // update form submit
      this._updateAddToCart(evt);
      // update live region
      this._updateLiveRegion(evt);

      this._updatePrice(evt);
      this._updateSKU(evt);
    },

    _updateImages: function(evt) {
      var variant = evt.variant;
      var imageId = variant.featured_image.id;

      this._switchImage(imageId);
      this._setActiveThumbnail(imageId);
    },

    _updatePrice: function(evt) {
      var variant = evt.variant;

      var $priceContainer = $(this.selectors.priceContainer, this.$container);
      var $regularPrice = $(this.selectors.regularPrice, $priceContainer);
      var $salePrice = $(this.selectors.salePrice, $priceContainer);
      var $unitPrice = $(this.selectors.unitPrice, $priceContainer);
      var $unitPriceBaseUnit = $(
        this.selectors.unitPriceBaseUnit,
        $priceContainer
      );

      // Reset product price state
      $priceContainer
      .removeClass(this.classes.productUnavailable)
      .removeClass(this.classes.productOnSale)
      .removeClass(this.classes.productUnitAvailable)
      .removeClass(this.classes.productSoldOut)
      .removeAttr('aria-hidden');

      this.$productPolicies.removeClass(this.classes.visibilityHidden);

      // Unavailable
      if (!variant) {
        $priceContainer
        .addClass(this.classes.productUnavailable)
        .attr('aria-hidden', true);

        this.$productPolicies.addClass(this.classes.visibilityHidden);
        return;
      }

      // Sold out
      if (!variant.available) {
        if (variant.compare_at_price > variant.price) {
          $priceContainer.addClass(this.classes.productOnSale);
        }else{
          $priceContainer.addClass(this.classes.productSoldOut);
        }
        
        return;
      }

      // On sale
      if (variant.compare_at_price > variant.price) {
        $regularPrice.html(
          theme.Currency.formatMoney(
            variant.compare_at_price,
            theme.moneyFormat
          )
        );
        $salePrice.html(
          theme.Currency.formatMoney(variant.price, theme.moneyFormat)
        );
        $priceContainer.addClass(this.classes.productOnSale);
      } else {
        // Regular price
        $regularPrice.html(
          theme.Currency.formatMoney(variant.price, theme.moneyFormat)
        );
      }

      // Unit price
      if (variant.unit_price) {
        $unitPrice.html(
          theme.Currency.formatMoney(variant.unit_price, theme.moneyFormat)
        );
        $unitPriceBaseUnit.html(this._getBaseUnit(variant));
        $priceContainer.addClass(this.classes.productUnitAvailable);
      }
    },

    _getBaseUnit: function(variant) {
      return variant.unit_price_measurement.reference_value === 1
      ? variant.unit_price_measurement.reference_unit
      : variant.unit_price_measurement.reference_value +
        variant.unit_price_measurement.reference_unit;
    },

    _updateSKU: function(evt) {
      var variant = evt.variant;

      // Update the sku
      $(this.selectors.SKU).html(variant.sku);
    },

    onUnload: function() {
      this.$container.off(this.settings.namespace);
    }
  });

  function _enableZoom(el) {
    var zoomUrl = $(el).data('zoom');
    $(el).zoom({
      url: zoomUrl,
      touch: true
    });
  }

  function _destroyZoom(el) {
    $(el).trigger('zoom.destroy');
  }
  var timer = setInterval(function(){ 
    if ($('.yotpo-container .yotpo .write-review .yotpo-header .yotpo-header-title').text().trim().length) {
      $('.yotpo-container .yotpo .write-review .yotpo-header .yotpo-header-title').empty();
      $('.yotpo-container .yotpo .write-review .yotpo-header .yotpo-header-title').text("Write a review");
      clearInterval(timer);
    }
  }, 100);
  enquire.register('screen and (max-width: 769px)', {
    match: function() {
      var timer1 = setInterval(function(){ 
        if($(".complete-the-set-section").length){ 
          $(".complete-the-set-section #productpage-nosto-4").appendTo(".complete-the-set-section-mob");
          clearInterval(timer1);
        }
      }, 100);
    },
    unmatch: function() {
    }
  });
  return Product;
})();

theme.DiscountBanner = (function(){

  var bannerContainer = $(".discount-banner");
  var banners = $(".discount-banner__link");
  var bannerCounter = 1;        

  function displayDiscountBanner(){

    if(bannerCounter != banners.length){
      $(banners).removeClass("inactive");       
      $(bannerContainer).find(".active").removeClass("active").addClass("inactive").next().addClass("active");
      bannerCounter++;          
    }else {
      $(banners).removeClass("inactive");
      $(bannerContainer).find(".active").removeClass("active").addClass("inactive");
      $(banners).first().addClass("active");
      bannerCounter = 1;  
    }

  }

  // setInterval(function(){ displayDiscountBanner(); }, 5000);


  //begin the multi-announcement banner toggle
  if ($("#discount-banner__link2").length) {
    //console.log('second message exists');
    function setMessageOne() {
      $('#discount-banner__link1').fadeIn(1000).delay(5000).fadeOut(1000, function () { if($('.discount-banner a').length > 1){ setMessageTwo();}else{setMessageOne();} });
    }

    function setMessageTwo() {
      $('#discount-banner__link2').fadeIn(1000).delay(5000).fadeOut(1000, function () { if($('.discount-banner a').length > 2){ setMessageThree();}else{setMessageOne();} });
    }

    function setMessageThree() {
      $('#discount-banner__link3').fadeIn(1000).delay(5000).fadeOut(1000, function () { if($('.discount-banner a').length > 3){ setMessageFour();}else{setMessageOne();} });
    }
    function setMessageFour() {
      $('#discount-banner__link4').fadeIn(1000).delay(5000).fadeOut(1000, function () { if($('.discount-banner a').length > 4){ setMessageFive();}else{setMessageOne();} });
    }
    function setMessageFive() {
      $('#discount-banner__link5').fadeIn(1000).delay(5000).fadeOut(1000, function () { setMessageOne(); });
    }
    setMessageOne();
  } else {
    $('#discount-banner__link1').show();
  }
})();
theme.Header = (function(){

  if($(window).width() > 768) {
    $(document).on("mouseenter mouseleave click", ".main-menu .level-1", function (e) {
      if($(window).width() > 1024) {
        if (e.type == "mouseenter") {
          $('.overlay-des').css({'opacity':'1','top':$('#shopify-section-header').outerHeight()+$("#shopify-section-discount-banner").outerHeight()});
        } else {
          $('.overlay-des').css('opacity','0');
        }
      }else{
        if (e.type == "click") {
          if($(this).hasClass('active-menu')){
            $(this).removeClass("active-menu");
            $('.overlay-des').css('opacity','0');
          }else{
            $(".main-menu .level-1").removeClass("active-menu");
            $(this).addClass("active-menu");
            $('.overlay-des').css({'opacity':'1','top':$('#shopify-section-header').outerHeight()+$("#shopify-section-discount-banner").outerHeight()});
          }

        }
        if (e.type == "mouseleave") {
          $(this).removeClass("active-menu");
          $('.overlay-des').css('opacity','0');
        }
      }

    });
  } 
  function openDrawer(){
//     $('.navigation-mb').css({
//       transform: 'translateX(0)',display: 'block'});
    $('.navigation-mb').css("display", 'flex');
    // $('.site-header').css("display", 'none');
    $('body,html').addClass('mb--over');
    $('.overlay').show();
  }

  function closeDrawer(){
//     $('.navigation-mb').css({
//       transform: 'translateX(-100%)', display: 'none'});
    $('.navigation-mb').css("display", 'none');
    $('.site-header').css("display", 'flex');
    $('body,html').removeClass('mb--over');
    $('.overlay').hide();
  }
  $('.menu-mb-icon button').click(function(){
    openDrawer();
    if($(this).attr('aria-expanded') == "false"){
      $(this).attr('aria-expanded',"true");
    }else{
      $(this).attr('aria-expanded',"false");
    }
  });
  $('.close-nav button,.overlay').click(function(){
    closeDrawer()
  });
  $('.navigation-mb .level-1 > a').click(function(e){
    e.preventDefault();
    $(this).closest('.level-1').find('.level-2').slideToggle('fast');
    // $(this).closest('.level-1').siblings().find('.level-2').hide('fast');
    $(this).toggleClass('active-menu');
    // $(this).closest('.level-1').siblings().children().first().removeClass('active-menu');
  });
//   $('.navigation-mb .level-2-link > a').click(function(e){
//     e.preventDefault();
//     $(this).closest('.level-2-link').find('.level-3').slideToggle('fast');
//     // $(this).closest('.level-2-link').siblings().find('.level-3').hide('fast');
//     var added = $(this).toggleClass('active-menu');
//     // $(this).closest('.level-2').find('a').not(added).removeClass('active-menu');
//   });
  $('.menu-mb-search button').click(function(){
    $('.search-form__container').toggle();
    if($(this).attr('aria-expanded') == "false"){
      $(this).attr('aria-expanded',"true");
    }else{
      $(this).attr('aria-expanded',"false");
    }
  })
})();
var time_auto = 5000;
if($('.template-index .slideshow').length && $('.template-index .slideshow').attr('data-time') != ''){
  time_auto = parseInt($('.template-index .slideshow').attr('data-time'));
}
var adaptiveHeight = false;
if($('.template-index .slideshow').length && $('.template-index .slideshow').attr('data-adaptiveHeight') != ''){
  adaptiveHeight = $('.template-index .slideshow').attr('data-adaptiveHeight');
}
$('.slideshow').slick({
  dots: true,
  autoplay: false,
  arrows: true,
  infinite: true,
  speed: 700,
  autoplaySpeed: time_auto,
  slidesToShow: 1,
  slidesToScroll: 1,
  dotsClass: 'btn-group',
  adaptiveHeight: adaptiveHeight,
  customPaging: function(slider, i) {
    var count = i+1;
    return '<div class="btn-item" id=' + count + ">0"+ count +"</div>";
  },
  prevArrow:'<button id="slick-prev" class="slick-prev slick-arrow" aria-label="Previous slide" type="button" title="Previous slide"><svg width="6" height="11" viewBox="0 0 6 11" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false"><path d="M5 1L1 5.5L5 10" stroke="white" /></svg></button>',
  nextArrow:'<button id="slick-next" class="slick-next slick-arrow" aria-label="Next slide" type="button" title="Next slide"><svg width="6" height="11" viewBox="0 0 6 11" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false"><path d="M1 10L5 5.5L1 1" stroke="white"/></svg></button>',

  responsive: [
    {
      breakpoint: 1024,
      settings: {

      }
    },
    {
      breakpoint: 767,
      settings: {
        customPaging: function(slider, i) {
          var count = i+1;
          return '<div class="btn-item" id=' + count + ">0"+ count +"/<small>0"+slider.slideCount+"</small></div>";
        }
        // appendDots: $('.slideshow__image-div')
      }
    }
  ]
});

function appsl(){
  if($('.product-list-slider').length > 0){
    if(!$('.product-list-slider').hasClass('slick-initialized')){
      $('.product-list-slider').slick({
        dots: false,
        arrows: true,
        slidesToShow: 4,
        slidesToScroll: 1,
        prevArrow: `
          <button id="slick-prev" class="slick-prev slick-arrow" aria-label="Previous slide" type="button" title="Previous slide">
            <svg width="6" height="11" viewBox="0 0 6 11" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false">
              <path d="M5 1L1 5.5L5 10" stroke="white"/>
            </svg>
          </button>
        `,
        nextArrow: `
          <button id="slick-next" class="slick-next slick-arrow" aria-label="Next slide" type="button" title="Next slide">
            <svg width="6" height="11" viewBox="0 0 6 11" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false">
              <path d="M1 10L5 5.5L1 1" stroke="white"/>
            </svg>
          </button>
        `,
        responsive: [
          {
            breakpoint: 769,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 1
            }
          },{
            breakpoint: 749,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1
            }
          }
        ]
      });
    }
  }else{
    setTimeout(function(){
      appsl();
    },500);
  }
}
  
appsl();

$('.product-featured-slider').slick({
  dots: false,
  arrows: true,
  slidesToShow: 1,
  slidesToScroll: 1,
  prevArrow:'<button id="slick-prev" class="slick-prev slick-arrow" aria-label="Prev" type="button"><svg width="9" height="17" viewBox="0 0 9 17" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M7.6665 1L0.999837 8.5L7.6665 16" stroke="#1E284B"/></svg></button>',
  nextArrow:'<button id="slick-next" class="slick-next slick-arrow" aria-label="Next" type="button"><svg width="9" height="17" viewBox="0 0 9 17" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1 1L7.66667 8.5L1 16" stroke="#1E284B"/></svg></button>'
});

$('.review-slideshow').slick({
  dots: false,
  arrows: false,
  slidesToShow: 1,
  slidesToScroll: 1,
  prevArrow:'<button id="slick-prev" class="slick-prev slick-arrow" aria-label="Previous slide" type="button" title="Previous slide"><svg width="9" height="17" viewBox="0 0 9 17" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false"><path d="M7.6665 1L0.999837 8.5L7.6665 16" stroke="#1E284B" /></svg></button>',
  nextArrow:'<button id="slick-next" class="slick-next slick-arrow" aria-label="Next slide" type="button title="Next slide"><svg width="9" height="17" viewBox="0 0 9 17" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false"><path d="M1 1L7.66667 8.5L1 16" stroke="#1E284B"/></svg></button>',
  dots:true,
  responsive: [
    {
      breakpoint: 749,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
  ]
});

$('.product-list-slider .swatches .swatch').click(function(){
  $(this).parent('.swatches').find('li').removeClass("active");
  $(this).addClass("active");
  var imgUrl = $(this).attr('rel');
  $(this).parents('.grid__item-prod').find(".prod-image img").attr("src",imgUrl);
});

$('.product-featured-slider .swatches .swatch').click(function(){
  $(this).parent('.swatches').find('li').removeClass("active");
  $(this).addClass("active");
  var imgUrl = $(this).attr('rel');
  $(this).parents('.grid__item-prod').find(".prod-image img").attr("src",imgUrl);
});


var slidertimer = setInterval(function(){ 
  if($(window).width() > 767) {
    var imgheight = $('.slideshow .slick-current.slick-active').find('.fordesktop.slideshow__image').height();
    $('.slideshow .btn-group').css({"bottom":"unset","top":$('.slideshow .slick-current.slick-active').find('.fordesktop.slideshow__image').height()-35});
    $('.slideshow .slick-next').css({"bottom":"unset","top":$('.slideshow .slick-current.slick-active').find('.fordesktop.slideshow__image').height()/2});
    $('.slideshow .slick-prev').css({"bottom":"unset","top":$('.slideshow .slick-current.slick-active').find('.fordesktop.slideshow__image').height()/2});
    $('.slideshow-wrapper .btnPlay').css({"bottom":"unset","top":$('.slideshow .slick-current.slick-active').find('.fordesktop.slideshow__image').height()/2});
    if(imgheight > 0){
      clearInterval(slidertimer);
    }
  }
  if($(window).width() < 768) {
    var imgheight = $('.slideshow .slick-current.slick-active').find('.formobile.slideshow__image').height();
    $('.slideshow .btn-group').css({"bottom":"unset","top":$('.slideshow .slick-current.slick-active').find('.formobile.slideshow__image').height()-34});
    $('.slideshow .slick-next').css({"bottom":"unset","top":$('.slideshow .slick-current.slick-active').find('.formobile.slideshow__image').height()/2});
    $('.slideshow .slick-prev').css({"bottom":"unset","top":$('.slideshow .slick-current.slick-active').find('.formobile.slideshow__image').height()/2});
    $('.slideshow-wrapper .btnPlay').css({"bottom":"unset","top":$('.slideshow .slick-current.slick-active').find('.fordesktop.slideshow__image').height()/2});
    if(imgheight > 0){
      clearInterval(slidertimer);
    }
  }
}, 100);
$('.slideshow').on('afterChange', function(event, slick, currentSlide, nextSlide){ 
  $('.slideshow .btn-group li').css({"color":$(slick.$slides[currentSlide]).find('.slideshow__slide ').data("dot-colort")}); 
  $('.slideshow .btn-group li.slick-active').css({"color":$(slick.$slides[currentSlide]).find('.slideshow__slide ').data("dot-color")});  
  $('.slideshow .btn-group li.slick-active').css({"border-color":$(slick.$slides[currentSlide]).find('.slideshow__slide ').data("dot-color")});  
  if($(window).width() > 767) {
    $('.slideshow .btn-group').css({"bottom":"unset","top":$('.slideshow .slick-current.slick-active').find('.fordesktop.slideshow__image').height()-35});
    $('.slideshow .slick-next').css({"bottom":"unset","top":$('.slideshow .slick-current.slick-active').find('.fordesktop.slideshow__image').height()/2});
    $('.slideshow .slick-prev').css({"bottom":"unset","top":$('.slideshow .slick-current.slick-active').find('.fordesktop.slideshow__image').height()/2});
  }
  if($(window).width() < 768) {
    $('.slideshow .btn-group').css({"bottom":"unset","top":$(slick.$slides[currentSlide]).find('.formobile.slideshow__image').height()-34});
    $('.slideshow .slick-next').css({"bottom":"unset","top":$(slick.$slides[currentSlide]).find('.formobile.slideshow__image').height()/2});
    $('.slideshow .slick-prev').css({"bottom":"unset","top":$(slick.$slides[currentSlide]).find('.formobile.slideshow__image').height()/2});
  }
});
$('.youtube-video-play').click(function () {
  event.preventDefault();
  $("#youtubevideo")[0].src += "?autoplay=1";
  $(".video-js").show();
  $('.video__inner .deskimg').hide();
  $('.video__inner .mobimg').hide();
  if ($(window).width() > 749) {
    $('.video--content').hide();
  }
});

$('body').on("click",".htmlvideo-js",function () {
  event.preventDefault();
  $('#htmlvideo').trigger('play');
  $(".video-js").show();
  $('.video__inner .deskimg').hide();
  $('.video__inner .mobimg').hide();
  if ($(window).width() > 749) {
    $('.video--content').hide();
  }
});
$('body').on("keyup",".htmlvideo-js",function (e) {
  e.preventDefault();
  if (e.keyCode == 13){
    $('#htmlvideo').trigger('play');
    $(".video-js").show();
    $('.video__inner .deskimg').hide();
    $('.video__inner .mobimg').hide();
    if ($(window).width() > 749) {
      $('.video--content').hide();
    }
  }
});
$('.product-youtube-video-js').click(function () {
  event.preventDefault();
  $("#product_youtubevideo")[0].src += "?autoplay=1";
  $(".product-video-js").show();
  $('.product-youtube-video-js').hide();
  $('.product-video__inner-div .deskimg').hide();
  $('.product-video__inner-div .mobimg').hide();
});

$('.product-htmlvideo-js').click(function () {
  event.preventDefault();
  $('#product_htmlvideo').trigger('play');
  $(".product-video-js").show();
  $('.product-htmlvideo-js').hide();
  $('.product-video__inner-div .deskimg').hide();
  $('.product-video__inner-div .mobimg').hide();
});
Shopify.queryParams = {};

if (location.search.length) {
  for (var aKeyValue, i = 0, aCouples = location.search.substr(1).split('&'); i < aCouples.length; i++) {
    aKeyValue = aCouples[i].split('=');
    if (aKeyValue.length > 1) {
      Shopify.queryParams[decodeURIComponent(aKeyValue[0])] = decodeURIComponent(aKeyValue[1]);
    }
  }
}

jQuery('.sort-by-selector')
.val(Shopify.queryParams.sort_by || 'best-selling')
.bind('change', function() {
  Shopify.queryParams.sort_by = jQuery(this).val();
  location.search = jQuery.param(Shopify.queryParams).replace(/\+/g, '%20');
});
var collFilters = jQuery('.collection-sidebar .filter-color input');

jQuery(document).on('change','.collection-sidebar .filter-color input',function() {
  var newTags = [];
  var colurl;
  var tagurl = jQuery(this).data('tag-url');
  var colHandle = jQuery(this).data('collection-handle');
  $('.collection-sidebar .filter-color input').each(function() {
    if ( jQuery(this).val() && jQuery(this).prop("checked") == true) {
      newTags.push(jQuery(this).val());
    }
  });

  if (newTags.length) {
    var query = newTags.join('+');
    console.log(tagurl + query);
    colurl = tagurl.replace('/' + 'tag', '/' + query);
  } else {
    colurl = '/collections/'+colHandle;
  }
  $.ajax({
    type: 'GET',
    url: colurl,
    data: {},
    beforeSend:function(){
      $('body').addClass('ajaxloading');
    },
    complete: function (data) {
      $('body').removeClass('ajaxloading');
      $('.product-list').html($(".product-list", data.responseText).html());
      $('#AjaxinatePagination').html($("#AjaxinatePagination", data.responseText).html());
      $('.collection-sidebar .filter-color').html($(".collection-sidebar .filter-color", data.responseText).html());
      $('.sortbar .product-count').html($(".sortbar .product-count", data.responseText).html());
      history.pushState({
        page: colurl
      }, colurl, colurl);
      document.addEventListener("DOMContentLoaded", function() {
        var endlessClick = new Ajaxinate({
          method: 'click'
        });
      });
    }
  });
});
jQuery(document).on('click','#AjaxinatePagination a',function(e) {
  e.preventDefault();
  var paginateUrl = jQuery(this).attr('href');
  $.ajax({
    type: 'GET',
    url: paginateUrl,
    data: {},
    beforeSend:function(){
      $('#AjaxinatePagination a').text('Loading...');
    },
    complete: function (data) {
      $('.product-list').append($(".product-list", data.responseText).html());
      $('#AjaxinatePagination').html($("#AjaxinatePagination", data.responseText).html());
      // $('#AjaxinatePagination a').text('Load More');
    }
  });
});
function openFilter(){
  $('#shopify-section-sidebar').css({
    transform: 'translateX(0)'
  });
  $('body,html').addClass('mb--over');
  $('.overlay').show();
}

function closeFilter(){
  $('#shopify-section-sidebar').css({
    transform: 'translateX(-100%)'
  });
  $('body,html').removeClass('mb--over');
  $('.overlay').hide();
}
$('.toolbar .filter-btn button').click(function(){
  openFilter();
});
$('.close-sidebar button,.overlay').click(function(){
  closeFilter()
});
theme.Cart = (function(){
  // if($(window).width()>768) {
  //     $('.mobilecartjs').remove();
  // }else{
  //     $('.desktopcartjs').remove();
  // }
  $(".js-appendaroundContent").appendAround();
})();
/*================ Templates ================*/
/**
 * Customer Addresses Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Customer Addresses
 * template.
 *
 * @namespace customerAddresses
 */

theme.customerAddresses = (function() {
  var $newAddressForm = $('#AddressNewForm');

  if (!$newAddressForm.length) {
    return;
  }

  // Initialize observers on address selectors, defined in shopify_common.js
  if (Shopify) {
    new Shopify.CountryProvinceSelector('AddressCountryNew', 'AddressProvinceNew', {
      hideElement: 'AddressProvinceContainerNew'
    });
  }

  // Initialize each edit form's country/province selector
  $('.address-country-option').each(function() {
    var formId = $(this).data('form-id');
    var countrySelector = 'AddressCountry_' + formId;
    var provinceSelector = 'AddressProvince_' + formId;
    var containerSelector = 'AddressProvinceContainer_' + formId;

    new Shopify.CountryProvinceSelector(countrySelector, provinceSelector, {
      hideElement: containerSelector
    });
  });

  // Toggle new/edit address forms
  $('.address-new-toggle').on('click', function() {
    $newAddressForm.toggleClass('hide');
  });

  $('.address-edit-toggle').on('click', function() {
    var formId = $(this).data('form-id');
    $('#EditAddress_' + formId).toggleClass('hide');
  });

  $('.address-delete').on('click', function() {
    var $el = $(this);
    var formId = $el.data('form-id');
    var confirmMessage = $el.data('confirm-message');
    if (confirm(confirmMessage || 'Are you sure you wish to delete this address?')) {
      Shopify.postLink('/account/addresses/' + formId, {parameters: {_method: 'delete'}});
    }
  });
})();

/**
 * Password Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Password template.
 *
 * @namespace password
 */

theme.customerLogin = (function() {
  var config = {
    recoverPasswordForm: '#RecoverPassword',
    hideRecoverPasswordLink: '#HideRecoverPasswordLink'
  };

  if (!$(config.recoverPasswordForm).length) {
    return;
  }

  checkUrlHash();
  resetPasswordSuccess();

  $(config.recoverPasswordForm).on('click', onShowHidePasswordForm);
  $(config.hideRecoverPasswordLink).on('click', onShowHidePasswordForm);

  function onShowHidePasswordForm(evt) {
    evt.preventDefault();
    toggleRecoverPasswordForm();
  }

  function checkUrlHash() {
    var hash = window.location.hash;

    // Allow deep linking to recover password form
    if (hash === '#recover') {
      toggleRecoverPasswordForm();
    }
  }

  /**
   *  Show/Hide recover password form
   */
  function toggleRecoverPasswordForm() {
    $('#RecoverPasswordForm').toggleClass('hide');
    $('#CustomerLoginForm').toggleClass('hide');
  }

  /**
   *  Show reset password success message
   */
  function resetPasswordSuccess() {
    var $formState = $('.reset-password-success');

    // check if reset password form was successfully submited.
    if (!$formState.length) {
      return;
    }

    // show success message
    $('#ResetSuccess').removeClass('hide');
  }
})();


$(document).ready(function () {
  var sections = new slate.Sections();
  sections.register('product', theme.Product);
  sections.register('discount-section', theme.DiscountBanner);
  sections.register('header-section', theme.Header);
  sections.register('cart-section', theme.Cart);
  sections.register('slideshow-section', theme.SlideshowSection);

  // Common a11y fixes
  slate.a11y.pageLinkFocus($(window.location.hash));

  $('.in-page-link').on('click', function (evt) {
    slate.a11y.pageLinkFocus($(evt.currentTarget.hash));
  });

  // Target tables to make them scrollable
  var tableSelectors = '.rte table';

  slate.rte.wrapTable({
    $tables: $(tableSelectors),
    tableWrapperClass: 'rte__table-wrapper',
  });

  // Target iframes to make them responsive
  var iframeSelectors =
      '.rte iframe[src*="youtube.com/embed"],' +
      '.rte iframe[src*="player.vimeo"]';

  slate.rte.wrapIframe({
    $iframes: $(iframeSelectors),
    iframeWrapperClass: 'rte__video-wrapper'
  });

  // Apply a specific class to the html element for browser support of cookies.
  if (slate.cart.cookiesEnabled()) {
    document.documentElement.className = document.documentElement.className.replace('supports-no-cookies', 'supports-cookies');
  }

  $(".account-container form").validate({
    rules: {
      "customer[firstname]": {
        required: true
      },

      "customer[email]": {
        required: true,
        email: true
      },
      "customer[password]": {
        required: true
      }
    },
    messages: {
      "customer[firstname]": {
        required: "Please enter your first name."
      },
      "customer[email]": {
        required: "Please enter your email address.",
        email: "Please enter a valid email address."
      },
      "customer[password]": {
        required: "Please enter a password."
      }
    }
  });
  $('#RecoverPasswordForm form').validate({
    rules: {
      "email": {
        required:true,
        email: true
      }
    },
    messages: {
      "email": {
        required:"Please enter your email address.",
        email: "Please enter a valid email address."
      }
    }
  });

  $('.inner_swatch input:checkbox').change(function(){
    var data_variant = $(this).attr('value');
    if($(this).is(":checked")) {
      $(this).addClass("addItem");
      $('.option_select').append('<input "type="hidden" value="'+ data_variant +'" name="id[]" class="d_'+data_variant+'">');
    } else {
      $(this).removeClass("addItem");
      $('.option_select .d_'+data_variant).remove();
    }
  });
  $('.inner_swatch').on("click", "input[type='radio']", function(){
    var previousValue = $(this).attr('previousValue');
    var name = $(this).attr('name');
    if (previousValue == 'checked') {
      $(this).removeAttr('checked');
      $(this).attr('previousValue', false);
      $(".product-form__cart-submit").attr('disabled',false);
    } else {
      $("input[name="+name+"]:radio").attr('previousValue', false);
      $(this).attr('previousValue', 'checked');
    }
    $('.option_select').html('');
    $("input[previousvalue='checked']").each(function(){
      var data_variant = $(this).val();
      var price = $(this).parent().find('.checkmark').attr('data-price');
      var com_price = $(this).parent().find('.checkmark').attr('data-compare-price');
      var val = $(this).parent('.color').parent('.inner_swatch').siblings('.more_info').find('.extra_price').find('.ComparePrice');
      var val_new = $(this).parent('.color').parent('.inner_swatch').siblings('.more_info').find('.extra_price');
      if($('.extra_price.free_product').length){
        val.text(price);
      }else{
        if(com_price){
          val_new.find('.currentprice').text(price);
          val_new.find('.ComparePrice').text(com_price);
        }else{
          val_new.find('.currentprice').text(price);
          val_new.find('.ComparePrice').text('');
        }
      }
      $('.option_select').append('<input "type="hidden" value="'+ data_variant +'" name="id[]" class="d_'+data_variant+'">');
    });
  });

  $('.check_select input:checkbox').change(function(){
    var id = $(this).attr("id");
    if($(this).is(":checked")) {
      $(".product-form__cart-submit").attr('disabled',false);
      $(".get_"+id).addClass("active_s");
      $(".get_"+id).closest('.upsell-option').addClass("active_u");
      $(this).attr('checked',true);
    } else {
      $(".get_"+id).removeClass("active_s");
      $(".get_"+id).closest('.upsell-option').removeClass("active_u");
      $(this).attr('checked',false);
    }
    $(this).closest('.upsell-option').find('input[type="radio"]').attr('previousValue', false).prop('checked', false);
    $('.option_select').html('');
    $("input[previousvalue='checked']").each(function(){
      var data_variant = $(this).val();
      $('.option_select').append('<input "type="hidden" value="'+ data_variant +'" name="id[]" class="d_'+data_variant+'">');
    });
  });


  $('.check_select input:radio').change(function(){
    $('.errorMsg').remove();
    var id = $(this).attr("id");
    $(".inner_swatch").removeClass("active_s");
    $('.upsell-option').removeClass("active_u");
    $(".product-form__cart-submit").attr('disabled',false);
    $(".get_"+id).addClass("active_s");
    $(".get_"+id).closest('.upsell-option').addClass("active_u");
    $('.upsell-option').find('input[type="radio"]').attr('previousValue', false).prop('checked', false);
    $(this).attr('previousValue', true).prop('checked', true);
    $('.option_select').html('');
    $("input[previousvalue='checked']").each(function(){
      var data_variant = $(this).val();
      $('.option_select').append('<input "type="hidden" value="'+ data_variant +'" name="id[]" class="d_'+data_variant+'">');
    });
  });


  $('.more_info_inner').click(function(){
    var id = $(this).find('a').attr('data-val');
    $('#id_'+id).addClass('show');
    $('html').addClass('active_extra');
  });
  $('.close').click(function(){
    $(this).closest('.poopup_extra').removeClass('show');
    $('html').removeClass('active_extra');
  });

  $('body :not(script)').contents().filter(function() {
    return this.nodeType === 3;
  }).replaceWith(function() {
    return this.nodeValue.replace(/[™®©]/g, '<sup>$&</sup>');
  });

});

jQuery(function () {
  jQuery('.swatch :radio').change(function () {
    var optionIndex = jQuery(this).closest('.swatch').attr('data-option-index');
    var optionValue = jQuery(this).val();
    jQuery(this)
    .closest('form')
    .find('.single-option-selector')
    .eq(optionIndex)
    .val(optionValue)
    .trigger('change');
  });
});
jQuery(document).ready(function () {
  // $(".product-template__container .compare_product a").on('click', function (e) {
  //   // e.preventDefault();
  //    console.log($("body").prop("scrollHeight")-$("#product-compare").offset().top,'qqqqqqqqqq');    
  //   $('html,body').animate({
  //     scrollTop: $("#product-compare").offset().top
  //   },'slow');
  // });  
  $('.qtyplus').click(function (e) {
    e.preventDefault();
    fieldName = $(this).attr('field');
    var currentVal = parseInt($('input[id=Quantity-' + fieldName + ']').val());
    if (!isNaN(currentVal)) {
      $('input[id=Quantity-' + fieldName + ']').val(currentVal + 1);
    }
  });
  $(".qtyminus").click(function (e) {
    e.preventDefault();
    fieldName = $(this).attr('field');
    var currentVal = parseInt($('input[id=Quantity-' + fieldName + ']').val());
    if (!isNaN(currentVal) && currentVal > 1) {
      $('input[id=Quantity-' + fieldName + ']').val(currentVal - 1);
    }
  });
  $(".show-more span").click(function () {
    if ($(this).hasClass("less")) {
      $(this).removeClass("less");
      $(this).html('Show More');
      $('.show-more-content').css('display', 'none');
      $('.icon-show-more').show();
      $('.icon-show-less').hide();
    } else {
      $(this).addClass("less");
      $(this).html('Show Less');
      $('.show-more-content').css('display', 'flex');
      $('.icon-show-more').hide();
      $('.icon-show-less').show();
    }
    $(this).parent().toggleClass('expand');

    return false;
  });

  $(document).on('click', '.tablinks', function () {
   var $this = $(this);
    var isActive = $this.hasClass('active-menu');

    // Toggle the 'active-menu' class
    $this.toggleClass('active-menu');

    // Toggle the aria-selected attribute based on the class
    $this.attr('aria-selected', !isActive);

    // Slide toggle the associated tab content
    $this.next().slideToggle();
  });
  
  $(document).on('click', ".view-above", function (e) {
    e.preventDefault();
    $('html,body').animate({
      scrollTop: $(".product-single__title").offset().top
    },
                           'slow');
  });
  
  
  if ($(window).width() < 768) {
    $(document).on('click', '.footer-accordion', function () {
      $(this).next().slideToggle();
      $(this).toggleClass('active-menu');
      $(this).closest('.site-footer__item').siblings().find('.site-footer__linklist').slideUp();
      $(this).closest('.site-footer__item').siblings().find('.footer-accordion').removeClass('active-menu');
    });
  }
  $(document).on('click', '.product-list .product-item .swatches .swatch', function () {
    $(this).parent('.swatches').find('li').removeClass("active");
    $(this).addClass("active");
    var imgUrl = $(this).attr('rel');
    $(this).parents('.product-item').find(".prod-image img").attr("src", imgUrl);
  });

  $(document).on('click', '.main-link', function () {
    $(this).next().slideToggle();
    $(this).toggleClass('active-menu');
  });
  $(document).on('click', '.sidebar-showmore', function () {
    if ($(this).hasClass('showless')) {
      $(this).removeClass('showless');
      $(this).text('Show More...');
      $('.collection-sidebar .categories_block .sidebar_categories .hide-links').slideToggle();
    } else {
      $(this).addClass('showless');
      $(this).text('Show Less');
      $('.collection-sidebar .categories_block .sidebar_categories .hide-links').slideToggle();
    }

  });
  $(document).on('click', ".product-template__container .writeRivew-toggle", function (e) {
    e.preventDefault();
    $('html,body').animate({
      scrollTop: $(".yotpo-container").offset().top
    },
                           'slow');
  });
  $selectNav = $(".js-selectNav");

  $("<select class='page-nav__select tab-grid-up--hide js-page-nav-select' />").appendTo($selectNav);

  $($selectNav).find("a").each(function() {
    var $item = $(this),
        $selected = $item.hasClass('current');
    $("<option />", {
      "value"     : $item.attr("href"),
      "text"      : $item.text(),
      "selected": $selected
    }).appendTo(".js-page-nav-select");

  });

  $selectNav.on("change",function() {
    $selectedNav = $(".js-page-nav-select option:selected");

    if ($selectedNav!=='') {
      window.location.href=$selectedNav.val();
    }
  });
  var instadiv = setInterval(function(){
    if($('#cs-instaPhoto-feed-page').length){
      $('#cs-instaPhoto-feed-page').find('img').attr('alt','Travelprointl');
      clearInterval(instadiv);
    }
  }, 100);
});



$(".mega-menu-dropdown ul li:last-child ul li:last-child a:last-child").addClass("lastchild");

$(".slideshow.slick-initialized.slick-slider.slick-dotted").prepend("<span class='sr-only'>Use arrow keys to navigate carousel slides</span>");


$( document ).ready(function() {
  $(".grid__item.small--one-half.medium-up--one-quarter.product-cta__item  a").addClass('shopitemtag');
  $(".grid__item.small--one-half.medium-up--one-quarter.product-cta__item  h1").addClass('shopitemh1tag');


  var j =1;
  $( ".shopitemtag" ).each(function() {
    var shoptext= $( this ).siblings( "h1" ).text();
    var res1 = shoptext.replace(" ", "-");
    $(this).attr('aria-labelledby',res1+'-Header'+j);
    j++;

  });

  var i =1;
  $( ".shopitemh1tag" ).each(function() {

    var shoptext1= $(this).text();
    var res = shoptext1.replace(" ", "-");
    $(this).attr('id',res+'-Header'+i);
    i++;

  });

});

$('.product-list-slider .slick-prev').attr('aria-label','Show previous products');

$('.product-list-slider .slick-next').attr('aria-label','Show next products');


$( ".header-section .navigation .main-menu > li" ).has( "div.mega-menu-dropdown" ).addClass( "mega-submenu" );

// $(".product-cta .product-cta__item img").attr('alt','');

// $(".template-collection .banner .header-banner img").attr('alt','');

$(".product-template__container .review-tab_product span").replaceWith(function() { return "<a class='writeRivew-toggle' href='#'>" + this.innerHTML + "</a>"; });

$(".product-template__container .reviews .reviews_content span:last-child").replaceWith(function() { return "<a class='writeRivew-toggle' href='#'>" + this.innerHTML + "</a>"; });

$(".mega-menu-dropdown").addClass("open-menu");

$("#Quantity-product").attr('role','alert');


$("#Quantity-product").attr('aria-live','polite');


$("#marketing").attr('tabindex','0');


$('.instafeed .card-body > center h3').replaceWith(function () {
  return "<h2 style='font-weight: 300;font-size: 1rem;font-family: Helvetica;letter-spacing: 0.2em;text-transform: uppercase;color: #1E284B !important;margin-bottom: 30px;font-style: normal;margin-top: 0;text-align: center;line-height: 26px;'>" + $(this).html() + "</h2>";
});

// $( ".header-section .navigation .main-menu > li .mega-menu-dropdown" ).addClass( "open-menu" );
/**
 * Applies the :focus-visible polyfill at the given scope.
 * A scope in this case is either the top-level Document or a Shadow Root.
 *
 * @param {(Document|ShadowRoot)} scope
 * @see https://github.com/WICG/focus-visible
 */
function applyFocusVisiblePolyfill(scope) {
  var hadKeyboardEvent = true;
  var hadFocusVisibleRecently = false;
  var hadFocusVisibleRecentlyTimeout = null;

  var inputTypesAllowlist = {
    text: true,
    search: true,
    url: true,
    tel: true,
    email: true,
    password: true,
    number: true,
    date: true,
    month: true,
    week: true,
    time: true,
    datetime: true,
    'datetime-local': true
  };

  /**
   * Helper function for legacy browsers and iframes which sometimes focus
   * elements like document, body, and non-interactive SVG.
   * @param {Element} el
   */
  function isValidFocusTarget(el) {
    if (
      el &&
      el !== document &&
      el.nodeName !== 'HTML' &&
      el.nodeName !== 'BODY' &&
      'classList' in el &&
      'contains' in el.classList
    ) {
      return true;
    }
    return false;
  }

  /**
   * Computes whether the given element should automatically trigger the
   * `focus-visible` class being added, i.e. whether it should always match
   * `:focus-visible` when focused.
   * @param {Element} el
   * @return {boolean}
   */
  function focusTriggersKeyboardModality(el) {
    var type = el.type;
    var tagName = el.tagName;

    if (tagName === 'INPUT' && inputTypesAllowlist[type] && !el.readOnly) {
      return true;
    }

    if (tagName === 'TEXTAREA' && !el.readOnly) {
      return true;
    }

    if (el.isContentEditable) {
      return true;
    }

    return false;
  }

  /**
   * Add the `focus-visible` class to the given element if it was not added by
   * the author.
   * @param {Element} el
   */
  function addFocusVisibleClass(el) {
    if(!$(el).parents('li.mega-submenu.active').length){
      $('ul.main-menu > li.mega-submenu.active').removeClass('active');
    }
    if (el.classList.contains('focus-visible')) {
      return;
    }
    el.classList.add('focus-visible');
    el.setAttribute('data-focus-visible-added', '');
  }

  /**
   * Remove the `focus-visible` class from the given element if it was not
   * originally added by the author.
   * @param {Element} el
   */
  function removeFocusVisibleClass(el) {
    if (!el.hasAttribute('data-focus-visible-added')) {
      return;
    }
    el.classList.remove('focus-visible');
    el.removeAttribute('data-focus-visible-added');
  }

  /**
   * If the most recent user interaction was via the keyboard;
   * and the key press did not include a meta, alt/option, or control key;
   * then the modality is keyboard. Otherwise, the modality is not keyboard.
   * Apply `focus-visible` to any current active element and keep track
   * of our keyboard modality state with `hadKeyboardEvent`.
   * @param {KeyboardEvent} e
   */
  function onKeyDown(e) {
    if (e.metaKey || e.altKey || e.ctrlKey) {
      return;
    }

    if (isValidFocusTarget(scope.activeElement)) {
      addFocusVisibleClass(scope.activeElement);
    }

    hadKeyboardEvent = true;
  }

  /**
   * If at any point a user clicks with a pointing device, ensure that we change
   * the modality away from keyboard.
   * This avoids the situation where a user presses a key on an already focused
   * element, and then clicks on a different element, focusing it with a
   * pointing device, while we still think we're in keyboard modality.
   * @param {Event} e
   */
  function onPointerDown(e) {
    hadKeyboardEvent = false;
  }

  /**
   * On `focus`, add the `focus-visible` class to the target if:
   * - the target received focus as a result of keyboard navigation, or
   * - the event target is an element that will likely require interaction
   *   via the keyboard (e.g. a text box)
   * @param {Event} e
   */
  function onFocus(e) {
    // Prevent IE from focusing the document or HTML element.
    if (!isValidFocusTarget(e.target)) {
      return;
    }

    if (hadKeyboardEvent || focusTriggersKeyboardModality(e.target)) {
      addFocusVisibleClass(e.target);
    }
  }

  /**
   * On `blur`, remove the `focus-visible` class from the target.
   * @param {Event} e
   */
  function onBlur(e) {
    if (!isValidFocusTarget(e.target)) {
      return;
    }

    if (
      e.target.classList.contains('focus-visible') ||
      e.target.hasAttribute('data-focus-visible-added')
    ) {
      // To detect a tab/window switch, we look for a blur event followed
      // rapidly by a visibility change.
      // If we don't see a visibility change within 100ms, it's probably a
      // regular focus change.
      hadFocusVisibleRecently = true;
      window.clearTimeout(hadFocusVisibleRecentlyTimeout);
      hadFocusVisibleRecentlyTimeout = window.setTimeout(function() {
        hadFocusVisibleRecently = false;
      }, 100);
      removeFocusVisibleClass(e.target);
    }
  }

  /**
   * If the user changes tabs, keep track of whether or not the previously
   * focused element had .focus-visible.
   * @param {Event} e
   */
  function onVisibilityChange(e) {
    if (document.visibilityState === 'hidden') {
      // If the tab becomes active again, the browser will handle calling focus
      // on the element (Safari actually calls it twice).
      // If this tab change caused a blur on an element with focus-visible,
      // re-apply the class when the user switches back to the tab.
      if (hadFocusVisibleRecently) {
        hadKeyboardEvent = true;
      }
      addInitialPointerMoveListeners();
    }
  }

  /**
   * Add a group of listeners to detect usage of any pointing devices.
   * These listeners will be added when the polyfill first loads, and anytime
   * the window is blurred, so that they are active when the window regains
   * focus.
   */
  function addInitialPointerMoveListeners() {
    document.addEventListener('mousemove', onInitialPointerMove);
    document.addEventListener('mousedown', onInitialPointerMove);
    document.addEventListener('mouseup', onInitialPointerMove);
    document.addEventListener('pointermove', onInitialPointerMove);
    document.addEventListener('pointerdown', onInitialPointerMove);
    document.addEventListener('pointerup', onInitialPointerMove);
    document.addEventListener('touchmove', onInitialPointerMove);
    document.addEventListener('touchstart', onInitialPointerMove);
    document.addEventListener('touchend', onInitialPointerMove);
  }

  function removeInitialPointerMoveListeners() {
    document.removeEventListener('mousemove', onInitialPointerMove);
    document.removeEventListener('mousedown', onInitialPointerMove);
    document.removeEventListener('mouseup', onInitialPointerMove);
    document.removeEventListener('pointermove', onInitialPointerMove);
    document.removeEventListener('pointerdown', onInitialPointerMove);
    document.removeEventListener('pointerup', onInitialPointerMove);
    document.removeEventListener('touchmove', onInitialPointerMove);
    document.removeEventListener('touchstart', onInitialPointerMove);
    document.removeEventListener('touchend', onInitialPointerMove);
  }

  /**
   * When the polfyill first loads, assume the user is in keyboard modality.
   * If any event is received from a pointing device (e.g. mouse, pointer,
   * touch), turn off keyboard modality.
   * This accounts for situations where focus enters the page from the URL bar.
   * @param {Event} e
   */
  function onInitialPointerMove(e) {
    // Work around a Safari quirk that fires a mousemove on <html> whenever the
    // window blurs, even if you're tabbing out of the page. ¯\_(ツ)_/¯
    if (e.target.nodeName && e.target.nodeName.toLowerCase() === 'html') {
      return;
    }

    hadKeyboardEvent = false;
    removeInitialPointerMoveListeners();
  }

  // For some kinds of state, we are interested in changes at the global scope
  // only. For example, global pointer input, global key presses and global
  // visibility change should affect the state at every scope:
  document.addEventListener('keydown', onKeyDown, true);
  document.addEventListener('mousedown', onPointerDown, true);
  document.addEventListener('pointerdown', onPointerDown, true);
  document.addEventListener('touchstart', onPointerDown, true);
  document.addEventListener('visibilitychange', onVisibilityChange, true);

  addInitialPointerMoveListeners();

  // For focus and blur, we specifically care about state changes in the local
  // scope. This is because focus / blur events that originate from within a
  // shadow root are not re-dispatched from the host element if it was already
  // the active element in its own scope:
  scope.addEventListener('focus', onFocus, true);
  scope.addEventListener('blur', onBlur, true);

  // We detect that a node is a ShadowRoot by ensuring that it is a
  // DocumentFragment and also has a host property. This check covers native
  // implementation and polyfill implementation transparently. If we only cared
  // about the native implementation, we could just check if the scope was
  // an instance of a ShadowRoot.
  if (scope.nodeType === Node.DOCUMENT_FRAGMENT_NODE && scope.host) {
    // Since a ShadowRoot is a special kind of DocumentFragment, it does not
    // have a root element to add a class to. So, we add this attribute to the
    // host element instead:
    scope.host.setAttribute('data-js-focus-visible', '');
  } else if (scope.nodeType === Node.DOCUMENT_NODE) {
    document.documentElement.classList.add('js-focus-visible');
    document.documentElement.setAttribute('data-js-focus-visible', '');
  }
}

// It is important to wrap all references to global window and document in
// these checks to support server-side rendering use cases
// @see https://github.com/WICG/focus-visible/issues/199
if (typeof window !== 'undefined' && typeof document !== 'undefined') {
  // Make the polyfill helper globally available. This can be used as a signal
  // to interested libraries that wish to coordinate with the polyfill for e.g.,
  // applying the polyfill to a shadow root:
  window.applyFocusVisiblePolyfill = applyFocusVisiblePolyfill;

  // Notify interested libraries of the polyfill's presence, in case the
  // polyfill was loaded lazily:
  var event;

  try {
    event = new CustomEvent('focus-visible-polyfill-ready');
  } catch (error) {
    // IE11 does not support using CustomEvent as a constructor directly:
    event = document.createEvent('CustomEvent');
    event.initCustomEvent('focus-visible-polyfill-ready', false, false, {});
  }

  window.dispatchEvent(event);
}

if (typeof document !== 'undefined') {
  // Apply the polyfill to the global document, so that no JavaScript
  // coordination is required to use the polyfill in the top-level document:
  applyFocusVisiblePolyfill(document);
}

/****26-08-2020*****/

// $(function () {
//     var popupSlide = $('.slideshow').slick({
//         autoplay: false,
//       "arrows": false, 
//        "fade": true,
//         slidesToShow: 1,
//         slidesToScroll: 1
//     });
// });

// (function($) {
//     $.fn.clickToggle = function(func1, func2) {
//         var funcs = [func1, func2];
//         this.data('toggleclicked', 0);
//         this.click(function() {
//             var data = $(this).data();
//             var tc = data.toggleclicked;
//             $.proxy(funcs[tc], this)();
//             data.toggleclicked = (tc + 1) % 2;
//         });
//         return this;
//     };
// }(jQuery));

$('.btnPlay').on('click', function(){
  var $pauseBtn = $(this);
  if ($pauseBtn.hasClass('paused')){
    $(".slideshow").slick('slickPlay');
    $pauseBtn.removeClass('paused');
  } else {
    $(".slideshow").slick('slickPause');
    $pauseBtn.addClass('paused');
  }
});

// $('.feature-row__image--right.lazyloaded img').attr('alt','');

// $('.product-icon-with-text-inner img').attr('alt','');

// $( ".grid__item.small--one-half.medium-up--one-quarter.product-cta__item" ).prepend( "<span class='sr-only'>&nbsp;Shop</span>" );


$('.yotpo-container .page-width h1').replaceWith(function () {
  return "<h2 >" + $(this).html() + "</h2>";
});

/* Keyboard Menu Focus */
function initMegaMenu() {
  var megaMenu = document.getElementById('mega-menu-main');
  // keyboard stuff
  $(megaMenu).delegate('li a, .hasimage a', 'keydown', keyboardHandler);  
  
//   var mega_menu_dropdown = $('.open-menu.mega-menu-dropdown');
//   mega_menu_dropdown.delegate('img', 'keydown', keyboardHandler);  
}


function keyboardHandler(keyVent) {
  var target = keyVent.target;
  var which = keyVent.which;

  if (which === 39) { // RIGHT
    if (isTopLevel(target)) {
      // top level item
      var nextTopItem = adjacentTopLevelItem(target, 'next');

      if (nextTopItem) {
        keyVent.preventDefault();
        nextTopItem.focus();
      }
    } else {
      // dropdown item
      var nextDropletItem = adjacentDropdownItem(target, 'next');
      if (nextDropletItem) {
        keyVent.preventDefault();
        nextDropletItem.focus();
      }
    }
  } else if (which === 37) { // LEFT
    if (isTopLevel(target)) {
      // top level item
      var prevTopItem = adjacentTopLevelItem(target, 'prev');

      if (prevTopItem) {
        keyVent.preventDefault();
        prevTopItem.focus();
      }
    } else {
      // dropdown item
      var prevDropItem = adjacentDropdownItem(target, 'prev');
      if (prevDropItem) {
        keyVent.preventDefault();
        prevDropItem.focus();
      }
    }
  } else if (which === 40) { // DOWN
    if (isTopLevel(target) && hasDropdown(target)) {
      // top level item w/ dropdown -- open dropdown
      openDropdown(target);
    } else {
      // dropdown item
      var nextDropItem = adjacentDropdownItem(target, 'next');

      if (nextDropItem) {
        keyVent.preventDefault();
        nextDropItem.focus();
      }
    }
  } else if (which === 38) { // UP
    if (!isTopLevel(target)) {
      if (isFirstDropItem(target)) {
        keyVent.preventDefault();
        var top = closeDropdown(target);
        setTimeout(function () {
          top.focus();
        }, 0);
      } else {
        var prevDropAnchor = adjacentDropdownItem(target, 'prev');

        if (prevDropAnchor) {
          keyVent.preventDefault();
          prevDropAnchor.focus();
        }
      }
    }
  } else if (which === 27) { // ESCAPE
    if (!isTopLevel(target)) {
      var topper = closeDropdown(target);
      setTimeout(function () {
        topper.focus();
      }, 0);
    }
  } else if (which === 9 && keyVent.shiftKey) { // SHIFT + TAB
    if (!isTopLevel(target) && isFirstDropItem(target)) {
      keyVent.preventDefault();
      var topA = closeDropdown(target);
      setTimeout(function () {
        topA.focus();
      }, 0);
    }
  } else if (which === 9) { // TAB
    if (!isTopLevel(target) && isLastDropItem(target)) {
      keyVent.preventDefault();
      var topItem = closeDropdown(target);
      var nextLi = $(topItem.parentNode).next()[0];
      var nextAnchor = $('a', nextLi)[0];
      nextAnchor.focus();
      
      console.log("==========");
      
    }
    console.log("ssssss");
  } else if (which === 13 || which === 32) {
    if (isTopLevel(target) && $(target.parentNode).hasClass('level-1')) {
      openDropdown(target);
    }
  }
}

// determines if the item is a top-level one
function isTopLevel(item) {
  return $(item).is('#mega-menu-main > li > a');
}

// determines if the item has a dropdown
function hasDropdown(item) {
  return $(item.parentNode).hasClass('level-1');
}

// determines if the item is the first in the dropdown
function isFirstDropItem(item) {
  var drop = $(item).closest('.mega-menu-dropdown')[0];
  var firstInDrop = $('li a, .hasimage a', drop)[0];

  return firstInDrop === item;

}

// determines if the item is the last in the dropdown
function isLastDropItem(item) {
  var drop = $(item).closest('.mega-menu-dropdown')[0];
  var lastInDrop = $('li a, .hasimage a', drop).last()[0];

  return lastInDrop === item;
}

// finds the adjacent top level item
function adjacentTopLevelItem(item, dir) {
  var li = item.parentNode; // <li />
  var adjacentLi = (dir === 'next') ?
      $(li).next()[0] :
  $(li).prev()[0];
  var adjacentItem = adjacentLi && $('a', adjacentLi)[0];

  return adjacentItem;
}

// finds the next or prev dropdown item
function adjacentDropdownItem(item, dir) {
  var adjacentDropItem;
  var li = item.parentNode;
  var adjacentSameCol = (dir === 'next') ?
      $(li).next()[0] :
  $(li).prev()[0];
  if (adjacentSameCol) {
    // there is one in the same col
    adjacentDropItem = $('a', adjacentSameCol)[0];
  } else {
    // lets look for one in the adjacent column
    var col = $(li).closest('.col')[0];
    var adjacentCol = (dir === 'next') ?
        $(col).next()[0] :
    $(col).prev()[0];
    if (adjacentCol) {
      
      console.log("sssssssssssssssssss");
      
      // we've found the adjacent column
      var adjacentItem = (dir === 'next') ?
          $('li a, .hasimage a', adjacentCol)[0] :
      $('li a, .hasimage a', adjacentCol).last()[0];

      if (adjacentItem) {
        adjacentDropItem = adjacentItem;
      }
    }
  }

  return adjacentDropItem;
}


function openDropdown(item) {
  $(item.parentNode).addClass('active-mega');
  var droplet = $(item).next()[0];
  // open the dropdown...
  $(droplet).slideDown(100);
  // ...and focus the first item
  setTimeout(function () {
    $('a', droplet)[0].focus();
  }, 100);
}

function closeDropdown(item) {
  var droplet = $(item).closest('.mega-menu-dropdown')[0];
  var topLevelItem = $(droplet).prev()[0];
  $(topLevelItem.parentNode).removeClass('active-mega');
  $(droplet).slideUp(100);

  return topLevelItem;
}

$(document).ready(initMegaMenu);


$('ul.main-menu li').hover(function () {     
  $(this).siblings('li').removeClass('active-mega');  	 
});

$(".video__inner .video--content .video-button span").attr('tabindex','0');


// $("ul.main-menu li a").hover(function(){
//   $(this).attr("aria-expanded", "true");
//   }, function(){
// $(this).unbind().attr("aria-expanded", "false");
// });
// , .hasimage a
$("ul.main-menu > li").mouseover(function() { 
  if($(this).hasClass('active')){
      
      $(this).find('button').attr( 'aria-expanded', 'true');
    }else{
      $(this).addClass('active mouseover');
      $(this).find('button').attr( 'aria-expanded', 'true');
    }      
}); 
$("ul.main-menu > li").mouseout(function() { 
  if($(this).hasClass('active')){
      $(this).removeClass('active mouseover');
      $(this).find('button').attr( 'aria-expanded', 'false');
    }
}); 

$('body').on("click",".image_wrapper.overlay_image",function(){
  window.location = $(this).data("href");
});

// HOME PAGE VIDEO SLICK

// $('body').on("keyup","li.mega-submenu a",function(e){
//   if(e.keyCode == 9){
// 	$(this).attr("aria-expanded", true);
//   }
// });



function get_slider(){
  if($('.slideshow.slick-initialized').length){
    setTimeout(function(){
      $('.slideshow .slideshow__text-wrap').addClass('active');
      $('.slideshow.slick-initialized').find('#slick-prev').attr({"role":"region", "aria-label":"Carousel controls"});
      $('.slideshow.slick-initialized').find('#slick-next').attr({"role":"region", "aria-label":"Carousel controls"});
      $('.slideshow.slick-initialized').attr({"role":"region", "aria-label":"Carousel"});
    },1000);
  }else{
    setTimeout(function(){
      get_slider();
    },700);
  } 
}
get_slider();



var mobile_iphone = (/iphone|ipod|android/i.test(navigator.userAgent.toLowerCase()));  
if (mobile_iphone) { 
  $('.play_button').css('display', 'none'); // OR you can use $('.navWrap').hide();
}



$('.down_arrow svg').click(function(){
    $('html, body').animate({
        scrollTop: $(".landing-joyfull").offset().top
    },1000);
});


$('.template-page .quick-nav-item').click(function(e){
  e.preventDefault();
    var handle = $(this).attr('data-handle');
    $('html, body').animate({
        scrollTop: $('#'+handle).offset().top
    }, 'slow');
    return false;
});

// table slider start here
$('.compare-pro-tab').slick({
  dots: false,
  infinite: false,
  speed: 300,
  slidesToShow: 5,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 991,
      settings: {
        slidesToShow: 4,
        slidesToScroll: 1,
      }
    },
     {
      breakpoint: 768,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
      }
    }
  ]
});

  const init = {
    autoplay: false,
    infinite: false,
    cssEase: "linear",
    slidesToShow: 2,
    arrows: false,
    dots: false,
    slidesToScroll: 1,
     responsive: [
     {
      breakpoint: 575,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
     ]
 };
if($('.feature-slider').hasClass('mobile_active_slider')){
 $(() => {
    const win = $(window);
    const slider = $(".feature-slider");


    win.on("load resize", () => {
        if (win.width() < 769) {
            slider.not(".slick-initialized").slick(init);
        } else if (slider.hasClass("slick-initialized")) {
            slider.slick("unslick");
        }
    });
  });
}
  $('.gallery-carousel').slick({
      dots: false,
      arrows: true,
      infinite: true,
      speed: 300,
      slidesToShow: 1,
      slidesToScroll: 1,
      centerMode: true,
      centerPadding: '30%',
      prevArrow:'<button type="button" class="slick-prev"><svg width="9" height="17" viewBox="0 0 9 17" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M7.6665 1L0.999837 8.5L7.6665 16" stroke="#1E284B"></path></svg></button>',
      nextArrow:'<button type="button" class="slick-next"><svg width="9" height="17" viewBox="0 0 9 17" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1 1L7.66667 8.5L1 16" stroke="#1E284B"></path></svg></button>',
      responsive: [
        {
          breakpoint: 1080,
          settings: {
              centerPadding: '25%',
          }
      },
      {
          breakpoint: 768,
          settings: {
              slidesToShow: 1,
              centerMode: false,
              dots: true,
              adaptiveHeight: true,
          }
      },
      ]
  });

  if($('.product__list__slider').hasClass('has_slider')){
     $('.product__list__slider.has_slider').slick({
        dots: false,
        arrows: true,
        infinite: true,
        speed: 300,
        slidesToShow: 4,
        slidesToScroll: 1,
        prevArrow:'<button type="button" class="slick-prev"><svg width="9" height="17" viewBox="0 0 9 17" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M7.6665 1L0.999837 8.5L7.6665 16" stroke="#1E284B"></path></svg></button>',
        nextArrow:'<button type="button" class="slick-next"><svg width="9" height="17" viewBox="0 0 9 17" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1 1L7.66667 8.5L1 16" stroke="#1E284B"></path></svg></button>',
        responsive: [
        {
            breakpoint: 992,
            settings: {
                slidesToShow: 3,
                centerMode: false,
            }
        },
        {
            breakpoint: 768,
            settings: {
                slidesToShow: 2,
                centerMode: false,
            }
        },
        {
            breakpoint: 426,
            settings: {
                slidesToShow: 1,
                centerMode: false,
            }
        },
        ]
    });
  }
       

/* Hotsport Icons JS : START  */

$(".video-pro-sec .left-section .img-wrp,.see_prodect_btn").on("click", function(e) {
  e.preventDefault();
  $(this).parents('.left-section').find(".mobile_tool").addClass("new_oprn");
  $("body").addClass("overflow_hidden_new" );
});

$(".mobile_top_wpr .mobile_tool_close,.mobile_tool_overlay").on("click", function() {
    $(this).parents('.left-section').find(".mobile_tool").removeClass("new_oprn");
    $("body").removeClass("overflow_hidden_new");
});

$('body').on('click','.mob_switches .tool_box_inner',function(e){
  e.preventDefault();
  var deatils = $(this).attr('data-deatils');
  $('.switch').removeClass('in-active');
  $(this).find('.switch').addClass('in-active');
  $(this).parents('.mobile_tool_top').find('.tool_popover__inner').hide();
  $(this).parents('.mobile_tool_top').find("#"+deatils).css('display','flex');
});


$('body').on('click','.tool_popover_close',function(){
  $(this).parents('.tool_popover').addClass('is-active');
});

$(".tool_main__wrapper .tool_box_inner").hover(function(){
  $(this).parent().find('.tool_popover').removeClass('is-active');
});


if($(window).width() < 768) {
  $('body').on('click','.gallery-slider-section .tool_box_inner',function(e){
    e.preventDefault();
    var detail_id = $(this).find('.switch').attr('data-deatils');
    $('.slick-current .tool_popover__wpr #'+detail_id).parents('.mobile_tool').addClass('new_oprn');
    $(this).parents('.video-pro-sec').find('.mobile_top_wpr').find('.tool_popover__wpr .tool_popover__inner').hide();
    $(this).parents('.video-pro-sec').find('.mobile_top_wpr').find('.tool_popover__wpr #'+detail_id).show();
  });

  $('body').on('click','.gallery-slider-section .tool_popover_close,.gallery-slider-section .overlay',function(e){
    e.preventDefault();
    $('.slick-current .tool_popover__wpr').parents('.mobile_tool').removeClass('new_oprn');
  });
}
$(window).resize(function() {
  if($(window).width() < 768) {
  $('body').on('click','.gallery-slider-section .tool_box_inner',function(e){
    e.preventDefault();
    var detail_id = $(this).find('.switch').attr('data-deatils');
    $('.slick-current .tool_popover__wpr #'+detail_id).parents('.mobile_tool').addClass('new_oprn');
    $(this).parents('.video-pro-sec').find('.mobile_top_wpr').find('.tool_popover__wpr .tool_popover__inner').hide();
    $(this).parents('.video-pro-sec').find('.mobile_top_wpr').find('.tool_popover__wpr #'+detail_id).show();
  });

  $('body').on('click','.gallery-slider-section .tool_popover_close,.gallery-slider-section .overlay',function(e){
    e.preventDefault();
    $('.slick-current .tool_popover__wpr').parents('.mobile_tool').removeClass('new_oprn');
  });
}

});
/* Hotsport Icons JS : END  */

/*-- Press-slider | 06-03-2024 --*/
$('.press-carousel').slick({
    dots: true,
    arrows: true,
    prevArrow: '<button type="button" class="slick-arrow prev-arrow" aria-label="Previous slide" title="Previous slide"><svg fill="#111" height="18" role="img" viewBox="0 0 18 18" width="18" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false"><path fill-rule="evenodd" clip-rule="evenodd" d="M8.2121 14.5196V14.7596L8.45578 15H10.4061L10.8928 14.7596L16.5 9.23965V8.75982L10.8928 3.23921L10.4061 3H8.45578L8.2121 3.23921V3.47984L12.6002 7.80014V8.04006L1.86409 8.0416L1.5 8.50308V9.5L1.86409 9.96183L12.6002 9.96029V10.2L8.2121 14.5196Z"></path></svg></button>',
    nextArrow: '<button type="button" class="slick-arrow next-arrow" aria-label="Next slide" title="Next slide"><svg fill="#111" height="18" role="img" viewBox="0 0 18 18" width="18" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false"><path fill-rule="evenodd" clip-rule="evenodd" d="M8.2121 14.5196V14.7596L8.45578 15H10.4061L10.8928 14.7596L16.5 9.23965V8.75982L10.8928 3.23921L10.4061 3H8.45578L8.2121 3.23921V3.47984L12.6002 7.80014V8.04006L1.86409 8.0416L1.5 8.50308V9.5L1.86409 9.96183L12.6002 9.96029V10.2L8.2121 14.5196Z"></path></svg></button>',
    loop: true,
    infinite: true,
    speed: 1000,
    slidesToShow: 1,
    slidesToScroll: 1,
});

/*-- Accordian Js [New Collection Update Page] --*/ 
$('.additional-collection-faq-content .acco-title h3').click(function () {
    $(this).toggleClass('active');
    $(this).parent('.acco-title').next().slideToggle();
});

/*-- Airline Size Guide Modal [Product Page] --*/ 
let lastFocusedElement = null;

$(".airline-size-guide-btn").on("click", function () {
  lastFocusedElement = $(this); // store the trigger button

  $(".airline-size-guide-modal").fadeIn(500).attr("aria-hidden", "false");

  // Focus the first focusable element inside modal
  const $modal = $(".airline-size-guide-modal");
  const $focusable = $modal.find("a, button, textarea, input, select").filter(":visible");

  if ($focusable.length) {
    $focusable.first().focus();
  }

  // Trap focus inside the modal
  $(document).on("keydown.modalFocusTrap", function (e) {
    if (e.key === "Tab") {
      const focusableElements = $focusable;
      const first = focusableElements.first()[0];
      const last = focusableElements.last()[0];

      if (e.shiftKey) {
        if (document.activeElement === first) {
          e.preventDefault();
          last.focus();
        }
      } else {
        if (document.activeElement === last) {
          e.preventDefault();
          first.focus();
        }
      }
    }

    // ESC to close
    if (e.key === "Escape") {
      closeModal();
    }
  });
});

function closeModal() {
  $(".airline-size-guide-modal").fadeOut(500).attr("aria-hidden", "true");
  $(document).off("keydown.modalFocusTrap");

  if (lastFocusedElement) {
    lastFocusedElement.focus();
  }
}

$(".airline-size-guide-modal .close-btn").on("click", function () {
  closeModal();
});


// Mini Cart Drawer Js [Globle Js]

function openCartDrawer(){
   $('.mini-cart-drawer').addClass('open');
   $('body').addClass('overflow-hidden');
}
function closeCartDrawer(){
  $('.mini-cart-drawer').removeClass('open');
  $('body').removeClass('overflow-hidden');
}
function cartRefresh(){
  $.get('/cart?view=alternate-cart', function (cart, textStatus) {
    var data = $(cart).find('.inner-mini-cart').html();
    $('.inner-mini-cart').html(data);
    mini_cart_drawer();
  });
  $.getJSON('/cart.js', function (cart, textStatus) {
    $('.pplr_cart_count').text(cart.item_count);
  }); 

}
function productQtyUpdate(id, quantity){
  $.ajax({
      url: "/cart/change.js",
      type: "POST",
      contentType: "application/json",
      data: JSON.stringify({
          id: id,
          quantity: quantity
      }),
      success: function(cartContent) {
          // Handle success
          cartRefresh();
        // update fenix edd in side cart  
        updateFenixEDD();
          
      },
      error: function(xhr, status, error) {
          // Handle error
          console.error("Error:", error);
      }
  });
}


function renderBeforeCartFenix(){
        // Check if the div with class name "fenix-delivery-estimate-cart" already exists
    var fenixDeliveryEstimateCart = document.querySelector('.fenix-delivery-estimate-cart');
    
    if (!fenixDeliveryEstimateCart) {
        // Create the new div element
        fenixDeliveryEstimateCart = document.createElement('div');
        fenixDeliveryEstimateCart.className = 'fenix-delivery-estimate-cart';

        // Get the div element with class name "mini-cart__actions"
        var miniCartActions = document.querySelector('.mini-cart__actions');

        // Insert the new div before the miniCartActions
        if (miniCartActions) {
            miniCartActions.parentNode.insertBefore(fenixDeliveryEstimateCart, miniCartActions);
        }
    }

    // Add the class name "travel-pro" to the "fenix-delivery-estimate-cart" div
    fenixDeliveryEstimateCart.classList.add('travel-pro');

}

function updateFenixEDD(){
  let xhr = new XMLHttpRequest();
  xhr.open('GET', `/cart.json`);
  xhr.onload = function() {
    setTimeout(() => {
      renderBeforeCartFenix();
       FenixDeliveryEstimates_Cart({
        cartitems: JSON.parse(xhr.response).items,
        shopurl: 'mytravelpro.myshopify.com'
      });
    }, 500)
  };
  xhr.send();
}

$('body').on('click', '#site-cart', function(e) {
   openCartDrawer();
   updateFenixEDD();
});


$('body').on('click', '.mini-cart-head .close-btn, .mini-cart-overlay, .btn.shopping-btn', function() {
  closeCartDrawer();
});
function mini_cart_drawer() {
    var mini_cart_headerHeight = $('.mini-cart-head').outerHeight();
    var mini_cart_footerHeight = $('.mini-cart-footer').outerHeight();
    var mini_cart_bodyHeight = mini_cart_headerHeight + mini_cart_footerHeight ;
    $('.mini-cart-body').css("height", "calc(100% - " + mini_cart_bodyHeight + "px)");
}
mini_cart_drawer();
$(window).on('resize', function () {
    mini_cart_drawer();
});

$('body').on('click', '.subtotal_discount_acco a', function(e) {
    $(".subtotal_discount_acco a").removeClass("active");
    $(".subtotal_discount_acco .subtotal_discount_content").slideUp();
    if (!$(this).next().is(":visible")) {
        $(this).next().slideDown();
        $(this).addClass("active");
    }
    if (!$(this).hasClass('active')) {
      $(".subtotal_discount_acco a").html("Show Order Summary");
    } else {
      $(".subtotal_discount_acco a").html("Hide Order Summary");
    }
    
});

// Mini Cart Drawer Qty Adjustment JS
 $('body').on('click', '.pro_qnty .qnty-btn', function(e) {
    e.preventDefault();
    var input = $(this).parent().find('.qnty-box input');
    var ip = parseInt(input.val());
    if ($(this).hasClass('plus-btn')) {
      ip = ip + 1;
    } else {
      ip = ip - 1;
    }
    if (ip == 0) {
      // return false;
    }
    input.val(ip);
    var id = input.attr('data-key');
    productQtyUpdate(id, ip);
  });

// slider product bundle gift
        $('.addons-carousel').slick({
            dots: true,
            arrows: true,
            infinite: false,
            speed: 800,
            slidesToShow: 1,
            slidesToScroll: 1,
        });

 // produuct gift Adjustment JS

$('body').on('keydown', '.add_ons_checkbox', function(e) {
  if (e.key === "Enter" || e.key === " ") {
    e.preventDefault();
    $(this).prop('checked', !$(this).prop('checked')).trigger('change');
  }
});

// Add To Cart JS ( ATC ) JS
$('body').on('click','.product-form__cart-submit',function(e){
  e.preventDefault();  
  let __btn_this = $(this);
   $(this).prop("disabled",true);
   $(this).parents('.product-form').attr("aria-busy","true");
  
  var selectedProducts = {
    items: []
  };

  // Collect selected add-ons
  $(".add_ons_checkbox[type='checkbox']:checked").each(function() {
    var checkboxId = $(this).parent('.custom-switch').attr('product-add-id');
    var qty = $('[name="quantity"]').val();
    selectedProducts.items.push({
      id: checkboxId,
      qty: qty
    });
  });

  // Collect main product data
  var form = $(this).closest('.product-form');
  var productId = form.find(".product-form__variants[name='id[]']").val();
  var quantity = form.find('[name="quantity"]').val();
  selectedProducts.items.push({
    id: productId,
    qty: quantity
  });

  
  $.ajax({
    url: '/cart/add.js',
    type: 'POST',
    data: selectedProducts,
    dataType: 'json',
    success: function() {
      $(__btn_this).parents('.product-form').attr("aria-busy","false");
      $('[data-product-status]').text('Item added to cart');
      $(__btn_this).prop("disabled",false);
      $(__btn_this).attr("aria-pressed",true);
     
      
      // rdt('track', 'AddToCart');
      openCartDrawer();
      cartRefresh();
      updateFenixEDD();
    },
    error: function(jqXHR, textStatus, errorThrown) {
      console.error("Error adding to cart:", textStatus, errorThrown);
      var response = $.parseJSON(jqXHR.responseText);
      $('.error').text(response.description).show();
      $(__btn_this).prop("disabled",false);
      setTimeout(function() {
        $('.error').hide();
      }, 10000);
    }
  });
});


// Add To Cart JS  Quick-Shop( ATC ) JS
   $('body').on('click','.product_fm .add-to-cart-btn',function(e){
     e.preventDefault();
     var params = {
      type: 'POST',
      url: '/cart/add.js',
      data: $(this).closest('form').serialize(),
      dataType: 'json',
      success: function(data){
        // rdt('track', 'AddToCart');
        openCartDrawer();  
        cartRefresh();
      },
      error: function(jqXHR, textStatus, errorThrown){
        var response = $.parseJSON(jqXHR.responseText);
          $('.error').text(response.description).show();
           setTimeout(function() {
             $('.error').hide();
           },10000)
      },
    };
    $.ajax(params);
    return false;
  });




  $('body').on('click','.product-gallery__expand__text',function(e){
    e.preventDefault();
    if($('.product-single__photo-wrapper').hasClass('is-expanded')){
      $('.product-single__photo-wrapper.is-expanded').toggleClass('expanded-images');
      $(this).text($(this).text() == "View more images" ? "View less images": "View more images");
    }
  });

  /* Product Gallery Model JS */
  $('body').on('click','.product-gallery__images__single.is-image,.close-zoom,.product-gallery__inner-bg',function(){
    $('.product-gallery__zoom-container').scrollTop(0);
    $('.product-gallery__zoom-container').addClass('hide');
    $('body').removeClass('overflow-hidden');
  });

  if ($(window).width() > 768) {
    $('body').on('click','.product-single__photo-wrapper.image_only',function(e){
      e.preventDefault();      
      $('.product-gallery__zoom-container').removeClass('hide');
      $('body').addClass('overflow-hidden');
      
      var targetId = $(this).find('.product-single__photo').attr('data-image-id');
      var targetDiv = $('.product-gallery__images__single[data-image-zoom-id="' + targetId + '"]');
            
      if (targetDiv.length) {
        $(".product-gallery__zoom-container").find(".product-gallery__images__single").hide();
        targetDiv.show();
        $('.product-gallery__zoom-container').scrollTop(targetDiv.position().top - $('.product-gallery__zoom-container').position().top + $('.product-gallery__zoom-container').scrollTop());
      }  
    });
  }


   $('body').on('click','.deferred-media__poster',function(e){
     e.preventDefault();
    var video = $(this).parents('.product-single_video').find('video')[0];
     
    if (video.paused) {
      video.play();
      $(this).hide(); 
    } else {
      video.pause();
      $(this).show(); 
    }
  });

  // Packing Accessories Carousel [Versa Pack Plus]
  $('.packing-accessories-carousel').slick({
      dots: false,
      arrows: true,
      prevArrow: '<button type="button" class="slick-arrow prev-arrow" aria-label="Previous slide" title="Previous slide"><svg width="15" height="32" viewBox="0 0 15 32" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false"><path d="M13.333 1L1.99968 15.5588L13.333 30.1176" stroke="black" stroke-width="3"/></svg></button>',
      nextArrow: '<button type="button" class="slick-arrow next-arrow" aria-label="Next slide" title="Next slide"><svg width="16" height="31" viewBox="0 0 16 31" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false"><path d="M1.88867 0.941406L13.222 15.5002L1.88867 30.0591" stroke="black" stroke-width="3"/></svg></button>',
      loop: false,
      infinite: false,
      speed: 1000,
      slidesToShow: 3,
      slidesToScroll: 1,
      responsive: [
      {
          breakpoint: 1024,
          settings: {
              slidesToShow: 3,
          }
      },
      {
          breakpoint: 769,
          settings: {
              slidesToShow: 2,
          }
      },
      {
          breakpoint: 480,
          settings: {
              slidesToShow: 1,
          }
      }
      ]
  });







  // video-block-hero [Versa Pack Plus Page]
  $('.versapackplus-media').click(function () {
    // Detect which video is currently visible (desktop or mobile)
    var $section = $(this).closest('.versapackplus-hero-section');
    var visibleVideo = $(this).find('video:visible')[0]; // Get only the visible one
    var this_v = $(this);
    if (visibleVideo.paused) {
      visibleVideo.play();
      $(this).find('.play-pause-btn').hide();
      $section.find('.logo-with-title').hide(); // Optional, hide logo
    } else {
      visibleVideo.pause();
      $(this).find('.play-pause-btn').show();
      $section.find('.logo-with-title').show();
    }
  });

  // video-block-hero [Versa Pack Plus Page]
  $('.underseat-tote-carousel').slick({
      dots: true,
      arrows: true,
      loop: false,
      infinite: false,
      speed: 1000,
      slidesToShow: 1,
      slidesToScroll: 1,
      prevArrow: '<button type="button" class="slick-arrow prev-arrow" aria-label="Previous slide" title="Previous slide"><svg width="15" height="32" viewBox="0 0 15 32" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false"><path d="M13.333 1L1.99968 15.5588L13.333 30.1176" stroke="black" stroke-width="3"/></svg></button>',
      nextArrow: '<button type="button" class="slick-arrow next-arrow" aria-label="Next slide" title="Next slide"><svg width="16" height="31" viewBox="0 0 16 31" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false"><path d="M1.88867 0.941406L13.222 15.5002L1.88867 30.0591" stroke="black" stroke-width="3"/></svg></button>',
  });

  $('.sub-underseat_carousel').slick({
      draggable: 'false',
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      asNavFor: '.sub-underseat_thumb_carousel',
      infinite: false,
      accessibility: false,
      swipeToSlide: false,
      swipe: false,
  });

  $('.sub-underseat_thumb_carousel').slick({
      draggable: 'false',
      infinite: false,
      slidesToShow: 5,
      slidesToScroll: 1,
      arrows: true,
      dots: false,
      swipe: false,
      focusOnSelect: true,
      asNavFor: '.sub-underseat_carousel',
      prevArrow: '<button type="button" class="slick-arrow prev-arrow" aria-label="Previous slide" title="Previous slide"><svg width="15" height="32" viewBox="0 0 15 32" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false"><path d="M13.333 1L1.99968 15.5588L13.333 30.1176" stroke="black" stroke-width="3"/></svg></button>',
      nextArrow: '<button type="button" class="slick-arrow next-arrow" aria-label="Next slide" title="Next slide"><svg width="16" height="31" viewBox="0 0 16 31" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false"><path d="M1.88867 0.941406L13.222 15.5002L1.88867 30.0591" stroke="black" stroke-width="3"/></svg></button>',
      responsive: [
      {
          breakpoint: 1024,
          settings: {
              arrows: true,
              swipe: false,
              slidesToShow: 4,
          }
      },
      {
          breakpoint: 769,
          settings: {
              slidesToShow: 4,
              arrows: false,
              swipe: true,
          }
      },
      {
          breakpoint: 320,
          settings: {
              slidesToShow: 4,
              arrows: false,
              swipe: true,
          }
      }
      ]
  });

  //
  $(".sub-underseat_thumb_carousel").each(function() {
      var sub_underseat_thumb = $(this).find('.slick-arrow').length;
      var sub_underseat_thumb_slide = 4;
      if (sub_underseat_thumb_slide <= sub_underseat_thumb || sub_underseat_thumb == sub_underseat_thumb_slide) {
          $(this).find('.slick-arrow').hide();
      } else {
          $(this).find('.slick-arrow').show();
      }
  });


let newImages = [];
$('body').on('click', '.product_swatches .swatch', function(e) {
  e.preventDefault();
  newImages = [];
  var _swa_this = $(this);
  var variant_url = $(this).attr('data-url');
  $.get(variant_url, function(response, status) {
    $(response).find('.product-single__photos').find('.product-single__photo-wrapper.image_only').each(function(i, v) {
      var new_src = $(v).find('.product-single__photo img').attr('src');
      newImages.push(new_src);
    });

    // Remove the existing slides and unslick the slider
    let $thumbCarousel = $(_swa_this).parents('.slide-content').find('.sub-underseat_thumb_carousel');
    let $mainCarousel = $(_swa_this).parents('.slide-content').find('.sub-underseat_carousel');
    
    $thumbCarousel.slick('unslick');
    $thumbCarousel.empty();
    $mainCarousel.slick('unslick');
    $mainCarousel.empty();

    // Create a string that contains all the slides
    let thumbSlides = '';
    newImages.forEach(function(imageUrl) {
      thumbSlides += `
        <div>
          <div class="thumb-slide-content">
            <div class="thumb_product-image">
              <img src="${imageUrl}">
            </div>
          </div>
        </div>`;
    });
    let mainSlides = '';
    newImages.forEach(function(imageUrl) {
      mainSlides += `
        <div>
          <div class="innner-slide-content">
            <div class="product-image">
              <img src="${imageUrl}" alt="Product Image">
            </div>
          </div>
        </div>`;
    });

    // Add all the slides to the carousel
    $thumbCarousel.html(thumbSlides);
    $mainCarousel.html(mainSlides);

    versThumb($thumbCarousel);
    versMainImg($mainCarousel);
  });
});

function versMainImg($carousel) {
  $carousel.slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      fade: false,
      asNavFor: '.sub-underseat_thumb_carousel',
      draggable: false,
      infinite: false,
  });
}

function versThumb($carousel) {
  $carousel.slick({
      infinite: false,
      slidesToShow: 4,
      slidesToScroll: 1,
      asNavFor: '.sub-underseat_carousel',
      arrows: true,
      dots: false,
      draggable: false,
      centerMode: false,
      focusOnSelect: true,
      centerPadding: '30px',
      prevArrow: '<button type="button" class="slick-arrow prev-arrow" aria-label="Previous slide" title="Previous slide"><svg width="15" height="32" viewBox="0 0 15 32" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false"><path d="M13.333 1L1.99968 15.5588L13.333 30.1176" stroke="black" stroke-width="3"/></svg></button>',
      nextArrow: '<button type="button" class="slick-arrow next-arrow" aria-label="Next slide" title="Next slide"><svg width="16" height="31" viewBox="0 0 16 31" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false"><path d="M1.88867 0.941406L13.222 15.5002L1.88867 30.0591" stroke="black" stroke-width="3"/></svg></button>',
  });
}

/* Search box open & close */
$('body').on('click','.icon.icon-search',function(){
  $('.search-form-content').find('.search-form__container').addClass('active');
});
$('body').on('click','.close-search-form',function(e){
  e.preventDefault();
  $(this).parents('.search-form__container').removeClass('active');
});

// Gift Modal JS [PDP Page] Start
  $('body').on('click', '.learn-more-btn', function(e) {
  e.preventDefault();

  const id = $(this).data('id');
  $('.inner-content').hide();
  $('.inner-content[data-id="' + id + '"]').show();
  $('.gift-purchase-modal').addClass("show").attr('aria-hidden', 'false');

  // Set focus to first focusable item inside modal
  const modal = document.querySelector('.gift-purchase-modal');
  const focusable = modal.querySelector('video, [tabindex]:not([tabindex="-1"]), button, a, input, select, textarea');
  if (focusable) focusable.focus();
});

// Close modal by overlay click
$('body').on('click', '.gift-purchase-modal .modal-overlay', function() {
  closeModal();
});

// Close modal by Escape key
$(document).on('keydown', function(e) {
  if (e.key === "Escape" && $('.gift-purchase-modal').hasClass('show')) {
    closeModal();
  }
});

function closeModal() {
  $('.gift-purchase-modal').removeClass("show").attr('aria-hidden', 'true');
  $('.inner-content').hide();

  // Return focus to the Learn More button that triggered the modal
  $('.learn-more-btn[data-id]').first().focus();
}

// Gift Modal JS [PDP Page] END


  // Handle clicks on hotspot buttons
  $('.inner-content .spot-list ul li').click(function(e) {
      e.preventDefault();
      $('.inner-content .spot-list ul li').removeClass('active');
      $(this).addClass('active');
      var index = $(this).find('button').data('index');    
      $('.product-features-carousel.slick-initialized').slick('slickGoTo', index-1);
  });

  /* Dot-feature & tab PDP */
 
  $('.product-features-carousel').slick({
      infinite: false,
      dots: true, 
      dotsClass: 'slider-paging-number',
      arrows: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: false,
      speed: 800,
      customPaging: function (slick, index) { 
          return '0'+(index + 1) + ' ' + '/' + ' ' + '0' + slick.slideCount; 
      }
  });
  //.on('afterChange', function (event, slick, currentSlide) {
  //   console.log(this);
  //     $(this).find('*[role="tablist"]').find('li').eq(0).text(slick.options.customPaging.call(this, slick, currentSlide));
  //    console.log(`currentSlide ${currentSlide}`);
  //    console.log(event);
      
  //     var currentIndex = currentSlide + 1;
  //     if( !eventTriggered ){
  //       $('.inner-content .spot-list ul li').removeClass('active');
  //       $('.inner-content .spot-list ul li').each(function() {
  //           if ($(this).find('button').data('index') === currentIndex) {
  //              console.log(currentIndex,'curenttttt====');
  //              console.log($(this).find('button').data('index'),'thissssss');
  //              $(this).addClass('active');
  //            eventTriggered = true;
  //           }
  //       });
  //     }
  //    eventTriggered = false;
  //});

function selectSlideEvent(currentIndex, slickElement){
  //$('.inner-content .spot-list ul li').removeClass('active');
  $(`#${slickElement}`).find('.inner-content .spot-list ul li').removeClass('active');
  if( $(`#${slickElement}`).find('.inner-content .spot-list ul li').length > 0 ){
    $(`#${slickElement}`).find('.inner-content .spot-list ul li').each(function() {      
      if (parseInt($(this).find('button').data('index')) === parseInt(currentIndex)) {
        console.log(currentIndex,'curenttttt====');
        console.log($(this).find('button').data('index'),'thissssss');
        $(this).addClass('active');     
      }
      // $('.product-features-carousel.slick-initialized').slick('slickGoTo', currentIndex);
    });
  }  
}
 function updatePagingNumber(slick, currentSlide) {
    var totalSlides = slick.slideCount; 
    var currentIndex = currentSlide + 1;
    var formattedPaging = '0' + currentIndex + ' / 0' + totalSlides;
   console.log(totalSlides);
   console.log(currentIndex);
   console.log(formattedPaging);
    //$('.custom-paging-number li').text(formattedPaging);
  }

$("body").on('click','.slick-next', function() {  
    var slickElement = $(this).closest(".indi-features-tab").find(".tab-nav li a.active").data("id");
    var SlickIndex = $(this).closest(".product-features-carousel").find(".slick-slide.slick-current.slick-active").attr("data-slick-index");    
  
    $(this).closest('.product-features-carousel.slick-initialized').slick('slickGoTo', SlickIndex);  
    SlickIndex = parseInt(SlickIndex)+1;   
    selectSlideEvent(SlickIndex, slickElement)

  });

  $("body").on('click', '.slick-prev' ,function() {
    var slickElement = $(this).closest(".indi-features-tab").find(".tab-nav li a.active").data("id");
    var SlickIndex = $(this).closest(".product-features-carousel").find(".slick-slide.slick-current.slick-active").attr("data-slick-index");    
    
    $(this).closest('.product-features-carousel.slick-initialized').slick('slickGoTo', SlickIndex);
    SlickIndex = parseInt(SlickIndex)+1;
    selectSlideEvent(SlickIndex, slickElement)
  })

// video section sltitude
$('body').on('click','.new_custom_video',function(e){
  e.preventDefault();  
    var $video = $(this).find('.desktop-video').get(0); // Get the video element
    if ($video.paused) {
      $video.play();
      console.log()
      $(this).find('.play-pause-video .play-icon').hide(); // Hide play button
     // $video.attr("controls", true);
      $(this).find('.play-pause-video .play_text').hide(); 
    } else {
      $video.pause();
       // $video.attr("controls", false);
      $(this).find('.play-pause-video .play-icon').show(); // Show play button
    }
  });

$('body').on('click','.underseat-tote-section .colors.swatch',function(e){
  e.preventDefault();  
  $(this).parents('.swatch_list').find('.colors.swatch').removeClass('active');
  $(this).addClass('active');
  var img_src = $(this).attr('data-img')
  $(this).parents('.item_wrapper').find('img').attr('src',img_src);
});

/*
$('.product-features-carousel').each(function() {
    var $carousel = $(this);

    // Initialize the slick slider for this specific carousel
    $carousel.slick({
      infinite: false,
      dots: true,
      dotsClass: 'slider-paging-number',
      arrows: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: false,
      speed: 800,
      customPaging: function (slick, index) {
        return '0' + (index + 1) + ' / 0' + slick.slideCount;
      }
    });

    // Bind the afterChange event only for this specific slider
    $carousel.on('afterChange', function (event, slick, currentSlide) {
      // Update the pagination text, or execute any custom logic
      $(this).find('*[role="tablist"]').find('li').eq(0).text(slick.options.customPaging.call(this, slick, currentSlide));
      
      console.log(`Current Slide: ${currentSlide} in Carousel ID: ${$carousel.attr('id')}`);

      var currentIndex = currentSlide + 1;
      $('.inner-content .spot-list ul li').removeClass('active');
      $('.inner-content .spot-list ul li').each(function() {
        if ($(this).find('button').data('index') === currentIndex) {
          $(this).addClass('active');
        }
      });
    });
  }); */




  // Indi Features Tab JS
  $('.indi-features-tab ul li a').click(function (e) {
      e.preventDefault();
      var tagid = $(this).attr('data-id');

      $('.indi-features-tab ul li a').removeClass('active');
      $(this).addClass('active');

      $(`#${tagid}`).find(".spot-list ul li").removeClass("active");
      $(`#${tagid}`).find(".spot-list ul li:first").addClass("active");
    
      $('.product-features-section .product-contents .tab-image-content').hide();
      $('.product-features-section .product-contents .tab-image-content#' + tagid).fadeIn(800);

      $('.indi-features-tab .tab-contents .tab-content').removeClass('current');
      $('.indi-features-tab .tab-contents .tab-content#' + tagid).addClass('current');

      // Reset the slider to the first slide and refresh it
      $('.product-features-carousel').slick('slickGoTo', 0).slick('refresh');
  });




$('.pro_size_list').on('click', 'li a', function() {
    $('.pro_size_list li a').removeClass('active');
    $(this).addClass('active');
});

// Perfect Size Section [Altitude Landing Page]
$('.perfect-size-carousel').slick({
    arrows: true,
    infinite: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    speed: 300,
    prevArrow: '<button type="button" class="slick-arrow prev-arrow" aria-label="Previous slide" title="Previous slide"><svg width="15" height="32" viewBox="0 0 15 32" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false"><path d="M13.333 1L1.99968 15.5588L13.333 30.1176" stroke="black" stroke-width="3"/></svg></button>',
    nextArrow: '<button type="button" class="slick-arrow next-arrow" aria-label="Next slide" title="Next slide"><svg width="16" height="31" viewBox="0 0 16 31" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false"><path d="M1.88867 0.941406L13.222 15.5002L1.88867 30.0591" stroke="black" stroke-width="3"/></svg></button>',
    autoplay: false,
    autoplaySpeed: 2000,
    responsive: [
    {
        breakpoint: 1024,
        settings: {
            slidesToShow: 3,
        }
    },
    {
        breakpoint: 769,
        settings: {
            slidesToShow: 2,
        }
    },
    {
        breakpoint: 481,
        settings: {
            slidesToShow: 1,
            centerMode: true, 
            centerPadding:'20px',
        }
    }
    ]
});


$('.Need-extra-room-carousel').slick({
    infinite: true,
    dots: false,
    arrows: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    prevArrow: '<button type="button" class="slick-arrow prev-arrow" aria-label="Previous slide" title="Previous slide"><svg width="15" height="32" viewBox="0 0 15 32" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false"><path d="M13.333 1L1.99968 15.5588L13.333 30.1176" stroke="black" stroke-width="3"/></svg></button>',
    nextArrow: '<button type="button" class="slick-arrow next-arrow" aria-label="Next slide" title="Next slide"><svg width="16" height="31" viewBox="0 0 16 31" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false"><path d="M1.88867 0.941406L13.222 15.5002L1.88867 30.0591" stroke="black" stroke-width="3"/></svg></button>',
    autoplay: false,
    autoplaySpeed: 5000,
    speed: 500,
    responsive: [{
        breakpoint: 1920,
        settings: {slidesToShow: 3,}
    },
    {
        breakpoint: 769,
        settings: {slidesToShow: 2,}
    },
    {
        breakpoint: 576,
        settings: {slidesToShow: 1,}
    }
    ]
});


// Compare-size flyout PDP
$('body').on('click','.compare_sizes_btn',function(e){
  e.preventDefault();
  $('.compare-sizes-drawer').addClass('open');
  $('body').addClass('overflow-hidden');
});
$('body').on('click','.close-btn,.overlay-bg',function(e){
  e.preventDefault();
  $('.compare-sizes-drawer').removeClass('open');
  $('body').removeClass('overflow-hidden');
});

// Fancybox carousel [Mobile]
if ($(window).width() <= 768) {
  Fancybox.bind("[data-fancybox]", {
    Thumbs: false,
    Carousel: {
    transition: 'slide',
    infinite: false, 
  }
   
  });
}

// Need-extra-room-carousel [Altitude Landing Page]
// $(window).on('resize load', function(){
//     function showSliderScreen() {
//         var $carousel = $('.Need-extra-room-carousel');
//         var slidesShow = 3;
//         var slideCount = $carousel.children().length;
//         var sliderSettings = {
            
//         }; 
//         if ($(window).width() > 768) {
//             if (slideCount > slidesShow) {
//                 if (!$carousel.hasClass("slick-initialized")) {
//                     $carousel.slick(sliderSettings);
//                 }
//             } else {
//                 if ($carousel.hasClass("slick-initialized")) {
//                     $carousel.slick("unslick");
//                 }
//             }
//         }
//         if ($(window).width() <= 768) {
//             if (!$carousel.hasClass("slick-initialized")) {
//                 $carousel.slick(sliderSettings);
//             }
//         }
//     }
//     showSliderScreen();
// });
// showSliderScreen();


// 04-09-2024 start press page h1 multiple remove
$('body.featured-press .rte.page-content > h1').remove();
// 04-09-2024 end


const sizeDropdown = document.querySelector('.size-dropdown-wrap');
if (sizeDropdown) {
  sizeDropdown.addEventListener('keydown', function(e) {
    if (e.key === ' ') {
      e.preventDefault();
      this.click(); // or toggle class/open logic here
    }
  });
}

const list = document.getElementById('size-list');
const trigger = document.querySelector('.size-dropdown-wrap');
if(trigger){
trigger.addEventListener('click', function () {
  const isOpen = this.getAttribute('aria-expanded') === 'true';

  this.setAttribute('aria-expanded', !isOpen);
  list.hidden = isOpen;
});
}



$(document).ready(function () {
  let cartlastFocusedElement = null;

  // Open drawer — example: cart icon button
  $('.site-cart.count-show').on('click', function (e) {
    e.preventDefault();
    cartlastFocusedElement = document.activeElement;

    const $drawer = $('.mini-cart-drawer');
    $drawer.addClass('open');

    // After a short delay (in case of CSS transitions or DOM rendering), focus the first focusable element
    setTimeout(() => {
      const $firstFocusable = $drawer.find(
        'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
      ).first();

      if ($firstFocusable.length) {
        $firstFocusable.focus();
      }
    }, 10); // Delay to ensure visibility and focusability
  });


  // Close on Escape key
  $(document).on('keydown', function (e) {
    if (e.key === 'Escape' || e.keyCode === 27) {
      if ($('.mini-cart-drawer').hasClass('open')) {
        closeCartDrawer();

        if (cartlastFocusedElement) {
          $(cartlastFocusedElement).focus();
        }
      }
    }
  });
});



  